import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { Grid, FormControl, InputLabel, Select, MenuItem, Button, Box, FormGroup, Checkbox, Chip, Avatar } from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import axios from "axios";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import "./bodyTypeDropDown.css";
import "./brandTypeDropDown.css";
import "./modelTypeDropDown.css";
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from "react-router-dom";
import { Divider } from "@mui/material";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { performAdvanceFilter } from './store'; 
import { useSnackbar } from 'notistack';
import { red } from "@mui/material/colors";
import { createPortal } from "react-dom";
import qs from "qs";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InputAdornment from "@mui/material/InputAdornment";
import "./filter.css";


// MoreFilterDialog Component
const DEFAULT_FILTERS = {
  colorSelect: "", carDriveType: "", carEngine: "", carFilterAccessories: [], carFuelType: "",
  carMileage: "", carPrice: "", carSeat: "", carSteering: "", carTransmission: "",
  categoryName: "", brandName: "", modelNames: [], years: [],
};

const COLOR_MAP = {
  WHITE: "#FFFFFF", PERL: "#EAE0C8", BEIGE: "#F5F5DC", SILVER: "#C0C0C0", GRAY: "#808080", 
  GUNMETAL: "#2a3439", BLACK: "#000000", PINK: "#FF1493", PURPLE: "#9932CC", WINE_RED: "#800000", 
  RED: "#FF0000", YELLOW: "#FFD700", ORANGE: "#FFA500", GOLD: "#FFD700", BROWN: "#8B4513", 
  LIGHT_BLUE: "#87CEEB", BLUE: "#0000FF", DARK_BLUE: "#00008B", GREEN: "#32CD32", MAZIORA: "#3B3B6D", 
  OTHER: "#808080" 
};

const MoreFilterDialog = ({
  open, onClose, onApplyFilters, initialFilters = {},
  currentData = { data: [], totalItems: 0 }
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Initialize selectedCategory from initialFilters
  const [selectedCategory, setSelectedCategory] = useState(() => {
    if (initialFilters.selectedCategory) {
      return initialFilters.selectedCategory;
    }
    if (initialFilters.categoryName) {
      return { label: initialFilters.categoryName };
    }
    return null;
  });

  // Initialize selectedBrand from initialFilters
  const [selectedBrand, setSelectedBrand] = useState(() => {
    if (initialFilters.selectedBrand) {
      return initialFilters.selectedBrand;
    }
    if (initialFilters.brandName) {
      return { label: initialFilters.brandName };
    }
    return null;
  });

  // Initialize selectedModels from initialFilters
  const [selectedModels, setSelectedModels] = useState(() => {
    const models = initialFilters.selectedModels || initialFilters.modelNames || [];
    if (Array.isArray(models)) {
      return models.map(m => 
        typeof m === 'object' ? m : { carModelName: m }
      ).filter(m => m.carModelName);
    }
    return [];
  });

  // Initialize selectedYears from initialFilters
  const [selectedYears, setSelectedYears] = useState(() => {
    const years = initialFilters.selectedYears || initialFilters.years || [];
    if (Array.isArray(years)) {
      return years
        .map(y => typeof y === 'object' ? y : { year: parseInt(y) })
        .filter(y => !isNaN(y.year));
    }
    return [];
  });

  // Sync state when dialog opens or initialFilters changes
  // useEffect(() => {
  //   if (open) {
  //     const category = initialFilters.selectedCategory || 
  //       (initialFilters.categoryName ? { label: initialFilters.categoryName } : null);
      
  //     const brand = initialFilters.selectedBrand || 
  //       (initialFilters.brandName ? { label: initialFilters.brandName } : null);
      
  //     const models = (initialFilters.selectedModels || initialFilters.modelNames || [])
  //       .map(m => typeof m === 'object' ? m : { carModelName: m })
  //       .filter(m => m.carModelName);
      
  //     const years = (initialFilters.selectedYears || initialFilters.years || [])
  //       .map(y => typeof y === 'object' ? y : { year: parseInt(y) })
  //       .filter(y => !isNaN(y.year));

  //     setSelectedCategory(category);
  //     setSelectedBrand(brand);
  //     setSelectedModels(models);
  //     setSelectedYears(years);
  //   }
  // }, [open, JSON.stringify(initialFilters)]);
  useEffect(() => {
  if (open) {
    const category = initialFilters.selectedCategory || 
      (initialFilters.categoryName ? { label: initialFilters.categoryName } : null);
    
    const brand = initialFilters.selectedBrand || 
      (initialFilters.brandName ? { label: initialFilters.brandName } : null);
    
    const models = (initialFilters.selectedModels || initialFilters.modelNames || [])
      .map(m => typeof m === 'object' ? m : { carModelName: m })
      .filter(m => m.carModelName);
    
    const years = (initialFilters.selectedYears || initialFilters.years || [])
      .map(y => typeof y === 'object' ? y : { year: parseInt(y) })
      .filter(y => !isNaN(y.year));

    setSelectedCategory(category);
    setSelectedBrand(brand);
    setSelectedModels(models);
    setSelectedYears(years);

    // ✅ YEH ADD KARO — baaki filters bhi sync karo
    setFilters(prev => ({
      ...prev,
      colorSelect:          initialFilters.colorSelect          || "",
      carPrice:             initialFilters.carPrice             || "",
      carMileage:           initialFilters.carMileage           || "",
      carEngine:            initialFilters.carEngine            || "",
      carFuelType:          initialFilters.carFuelType          || "",
      carDriveType:         initialFilters.carDriveType         || "",
      carTransmission:      initialFilters.carTransmission      || "",
      carSteering:          initialFilters.carSteering          || "",
      carSeat:              initialFilters.carSeat              || "",
      carFilterAccessories: initialFilters.carFilterAccessories || [],
    }));
  }
}, [open, JSON.stringify(initialFilters)]);

  // DROPDOWN OPEN/CLOSE STATES
  const [isBodyTypeOpen, setIsBodyTypeOpen] = useState(false);
  const [isBrandOpen, setIsBrandOpen] = useState(false);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isYearOpen, setIsYearOpen] = useState(false);

  const [isBrandsLoading, setIsBrandsLoading] = useState(false);
  const [isModelsLoading, setIsModelsLoading] = useState(false);
  const [isYearsLoading, setIsYearsLoading] = useState(false);
  const [isCategoriesLoading, setIsCategoriesLoading] = useState(false);
  const [yearsFetched, setYearsFetched] = useState(false);

  const [bodyTypes, setBodyTypes] = useState([]);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [years, setYears] = useState([]);

  const [filters, setFilters] = useState(() => { 
    const initial = { 
      ...DEFAULT_FILTERS, 
      ...initialFilters 
    };
    
    return {
      ...initial,
      modelNames: Array.isArray(initial.modelNames) ? initial.modelNames : [],
      years: Array.isArray(initial.years) ? initial.years : [],
      carFilterAccessories: Array.isArray(initial.carFilterAccessories) ? initial.carFilterAccessories : []
    };
  });

  const [allOptions, setAllOptions] = useState({
    colors: [], driveTypes: [], engines: [], accessories: [], fuelTypes: [], 
    mileages: [], prices: [], seats: [], steerings: [], transmissions: []
  });
  
  const [loading, setLoading] = useState(false);
  const [filteredTotalItems, setFilteredTotalItems] = useState(
    currentData?.totalItems || 0
  );

  const debounceRef = useRef(null);
  const overlayRef = useRef(null);
  const bodyTypeRef = useRef(null);
  const brandRef = useRef(null);
  const modelRef = useRef(null);
  const yearRef = useRef(null);

  const POPULAR_MODELS = [ "PRIUS", "FREED", "AUDI A8", "BEGO", "BMW Z4", "ROOX", "HUSTLER", "BENTLEY" ];
  const POPULAR_BRANDS = [ "TOYOTA", "FORD", "AUDI", "GMC", "BMW", "NISSAN", "SAAB", "VOLVO" ];

  // ===== UTILITY FUNCTIONS =====
  const formatBrandName = (brandName) => { 
    if (!brandName) return ""; 
    return brandName.trim().toUpperCase().replace(/\s+/g, ''); 
  };
  
  const formatModelName = (modelName) => { 
    if (!modelName) return ""; 
    return modelName.trim(); 
  };

  const getCategoryIcon = (categoryName) => {
    const iconMap = { 
      SEDAN: "/BrandIcons/body1.svg", 
      SUV: "/BrandIcons/body2.svg", 
      WELFARE: "/BrandIcons/body2.svg", 
      HATCHBACK: "/BrandIcons/body3.svg", 
      VAN: "/BrandIcons/body4.svg", 
      CAB_VAN: "/BrandIcons/body4.svg", 
      CONVERTIBLE: "/BrandIcons/body5.svg", 
      COUPE: "/BrandIcons/body6.svg", 
      WAGON: "/BrandIcons/body6.svg", 
      BUS: "/BrandIcons/body6.svg", 
      TRUCK: "/BrandIcons/body7.svg", 
      DUMP: "/BrandIcons/body7.svg", 
      PICK_UP_TRUCK: "/BrandIcons/body7.svg", 
      MINI_VAN: "/BrandIcons/body4.svg", 
      NO_CATEGORIES_NAME: "/BrandIcons/body6.svg", 
      OPEN: "/BrandIcons/body5.svg" 
    };
    return iconMap[categoryName.toUpperCase()] || "/BrandIcons/default.svg";
  };

  const getBrandImage = (brandName) => {
    const imageMap = {
      "ALFAROMEO": "/BrandIcons/Brand_Alfa_Romeo.svg",
      "ALPINA": "/BrandIcons/Brand_Alpina.svg",
      "AUDI": "/BrandIcons/Brand_Audi.svg",
      "BMW": "/BrandIcons/Brand_BMW.svg",
      "FORD": "/BrandIcons/Brand_Ford.svg",
      "HONDA": "/BrandIcons/Brand_Honda.svg",
      "TOYOTA": "/BrandIcons/Brand_Toyota.svg",
      "NISSAN": "/BrandIcons/Brand_Nissan.svg",
    };
    return imageMap[brandName] || imageMap[formatBrandName(brandName)] || "/BrandIcons/default.svg";
  };

  const getModelImage = (modelName) => {
    const imageMap = {
      "PRIUS": "/BrandIcons/Brand_Toyota.svg",
      "FREED": "/BrandIcons/Brand_Honda.svg",
      "AUDI A8": "/BrandIcons/Brand_Audi.svg",
      "BMW Z4": "/BrandIcons/Brand_BMW.svg",
    };
    return imageMap[modelName];
  };

  // ===== FETCH FUNCTIONS =====
  const fetchAllCategories = useCallback(async () => {
    try {
      const response = await fetch("https://car.amar.co.jp/api/master/car-catgories/get-all-categories", { 
        headers: { Accept: "application/json", "Accept-Language": "en" } 
      });
      const result = await response.json();
      if (result.status === 200 && result.data) {
        const mappedBodyTypes = result.data.map((category) => ({
          label: category.categoriesName.trim() === "NO_CATEGORIES_NAME" ? "CONVERTIBLE" : category.categoriesName.trim(),
          src: getCategoryIcon(category.categoriesName.trim()),
        }));
        setBodyTypes(mappedBodyTypes);
      }
    } catch (error) { 
      console.error("Error fetching categories:", error); 
    }
  }, []);

  // FIXED: fetchAllBrands now accepts category parameter
  // const fetchAllBrands = useCallback(async (categoryToUse = null) => {
  //   try {
  //     const category = categoryToUse || selectedCategory;
  //     if (category) {
  //       const queryParams = { 
  //         categoryName: category.label, 
  //         page: 0, 
  //         size: 100 
  //       };
  //       const response = await axios.get('https://car.amar.co.jp/api/dashboard/filter/advance-filter-new', { 
  //         params: queryParams, 
  //         headers: { Accept: "application/json", "Accept-Language": "en" } 
  //       });
  //       const data = response.data;
  //       if (data.data && Array.isArray(data.data)) {
  //         const uniqueBrands = Array.from(
  //           new Set(data.data.map(item => item.carBrandName).filter(Boolean))
  //         ).map(brandName => ({ carBrandName: formatBrandName(brandName) }));
  //         setBrands(uniqueBrands);
  //       } else {
  //         setBrands([]);
  //       }
  //     } else {
  //       const response = await axios.get("https://car.amar.co.jp/api/master/car-brand/get-all-brandName", { 
  //         headers: { accept: "application/json", "Accept-Language": "en" } 
  //       });
  //       if (response.data.carBrandList) { 
  //         setBrands(response.data.carBrandList); 
  //       } else {
  //         setBrands([]);
  //       }
  //     }
  //   } catch (error) { 
  //     console.error("Error fetching brands:", error); 
  //   }
  // }, [selectedCategory]);
  const fetchAllBrands = useCallback(async (categoryToUse = null) => {
  setIsBrandsLoading(true);
  setBrands([]); // ✅ Pehle clear karo
  try {
    const category = categoryToUse || selectedCategory;
    if (category) {
      const queryParams = { categoryName: category.label, page: 0, size: 100 };
      const response = await axios.get('https://car.amar.co.jp/api/dashboard/filter/advance-filter-new', {
        params: queryParams,
        headers: { Accept: "application/json", "Accept-Language": "en" }
      });
      const data = response.data;
      if (data.data && Array.isArray(data.data)) {
        const uniqueBrands = Array.from(
          new Set(data.data.map(item => item.carBrandName).filter(Boolean))
        ).map(brandName => ({ carBrandName: formatBrandName(brandName) }));
        setBrands(uniqueBrands);
      } else {
        setBrands([]);
      }
    } else {
      const response = await axios.get("https://car.amar.co.jp/api/master/car-brand/get-all-brandName", {
        headers: { accept: "application/json", "Accept-Language": "en" }
      });
      if (response.data.carBrandList) {
        setBrands(response.data.carBrandList);
      } else {
        setBrands([]);
      }
    }
  } catch (error) {
    console.error("Error fetching brands:", error);
  } finally {
    setIsBrandsLoading(false); // ✅
  }
}, [selectedCategory]);

  // FIXED: fetchAllModels now accepts category and brand parameters
  // const fetchAllModels = useCallback(async (categoryToUse = null, brandToUse = null) => {
  //   try {
  //     const category = categoryToUse || selectedCategory;
  //     const brand = brandToUse || selectedBrand;
      
  //     const categoryName = category?.label || "";
  //     const brandName = brand?.label || "";

  //     const params = { 
  //       categoryName: categoryName, 
  //       brandName: brandName, 
  //       page: '0', 
  //       size: '100' 
  //     };
      
  //     const response = await axios.get('https://car.amar.co.jp/api/dashboard/filter/advance-filter-new', { 
  //       params: params, 
  //       headers: { Accept: "application/json", "Accept-Language": "en" } 
  //     });
      
  //     const data = response.data;
  //     if (data.data && Array.isArray(data.data)) {
  //       const uniqueModels = Array.from(
  //         new Set(data.data.map(item => item.carModelName).filter(Boolean))
  //       ).map(modelName => ({ carModelName: formatModelName(modelName) }));
  //       setModels(uniqueModels);
  //     } else { 
  //       setModels([]);
  //     }
  //   } catch (error) { 
  //     console.error("Error fetching models:", error); 
  //     setModels([]);
  //   }
  // }, [selectedCategory, selectedBrand]);
//   const fetchAllModels = useCallback(async (categoryToUse = null, brandToUse = null) => {
//   try {
//     const category = categoryToUse || selectedCategory;
//     const brand = brandToUse || selectedBrand;

//     // ✅ Agar koi filter nahi — master API se poori list lo
//     if (!category && !brand) {
//       const response = await axios.get(
//         'https://car.amar.co.jp/api/master/car-model/get/unique/model',
//         { headers: { Accept: "application/json", "Accept-Language": "en" } }
//       );

//       if (response.data?.carModelList && Array.isArray(response.data.carModelList)) {
//         const allModels = response.data.carModelList.map(item => ({
//           carModelName: formatModelName(item.carModelName)
//         }));
//         setModels(allModels);
//       } else {
//         setModels([]);
//       }
//       return;
//     }

//     // ✅ Category ya brand selected hai — filtered API
//     const categoryName = category?.label || "";
//     const brandName = brand?.label || "";

//     const params = {
//       categoryName: categoryName,
//       brandName: brandName,
//       page: '0',
//       size: '100'
//     };

//     const response = await axios.get(
//       'https://car.amar.co.jp/api/dashboard/filter/advance-filter-new',
//       { params, headers: { Accept: "application/json", "Accept-Language": "en" } }
//     );

//     const data = response.data;
//     if (data.data && Array.isArray(data.data)) {
//       const uniqueModels = Array.from(
//         new Set(data.data.map(item => item.carModelName).filter(Boolean))
//       ).map(modelName => ({ carModelName: formatModelName(modelName) }));
//       setModels(uniqueModels);
//     } else {
//       setModels([]);
//     }
//   } catch (error) {
//     console.error("Error fetching models:", error);
//     setModels([]);
//   }
// }, [selectedCategory, selectedBrand]);
// const fetchAllModels = useCallback(async (categoryToUse = null, brandToUse = null) => {
//   setIsModelsLoading(true);
//   setModels([]); // ✅ Pehle clear karo
//   try {
//     const category = categoryToUse || selectedCategory;
//     const brand = brandToUse || selectedBrand;

//     if (!category && !brand) {
//       const response = await axios.get(
//         'https://car.amar.co.jp/api/master/car-model/get/unique/model',
//         { headers: { Accept: "application/json", "Accept-Language": "en" } }
//       );
//       if (response.data?.carModelList && Array.isArray(response.data.carModelList)) {
//         const allModels = response.data.carModelList.map(item => ({
//           carModelName: formatModelName(item.carModelName)
//         }));
//         setModels(allModels);
//       } else {
//         setModels([]);
//       }
//       return;
//     }

//     const categoryName = category?.label || "";
//     const brandName = brand?.label || "";
//     const params = { categoryName, brandName, page: '0', size: '100' };

//     const response = await axios.get(
//       'https://car.amar.co.jp/api/dashboard/filter/advance-filter-new',
//       { params, headers: { Accept: "application/json", "Accept-Language": "en" } }
//     );

//     const data = response.data;
//     if (data.data && Array.isArray(data.data)) {
//       const uniqueModels = Array.from(
//         new Set(data.data.map(item => item.carModelName).filter(Boolean))
//       ).map(modelName => ({ carModelName: formatModelName(modelName) }));
//       setModels(uniqueModels);
//     } else {
//       setModels([]);
//     }
//   } catch (error) {
//     console.error("Error fetching models:", error);
//     setModels([]);
//   } finally {
//     setIsModelsLoading(false); // ✅
//   }
// }, [selectedCategory, selectedBrand]);
// const fetchAllModels = useCallback(async (categoryToUse = null, brandToUse = null) => {
//   setIsModelsLoading(true);
//   setModels([]);
//   try {
//     const category = categoryToUse || selectedCategory;
//     const brand = brandToUse || selectedBrand;

//     // Master API se saare models fetch karo
//     const response = await axios.get(
//       'https://car.amar.co.jp/api/master/car-model/get/unique/model',
//       { headers: { Accept: "application/json", "Accept-Language": "en" } }
//     );

//     if (response.data?.carModelList && Array.isArray(response.data.carModelList)) {
//       let allModelsList = response.data.carModelList.map(item => ({
//         carModelName: formatModelName(item.carModelName)
//       }));

//       // Agar brand selected hai toh brand prefix se filter karo
//       if (brand?.label) {
//         const brandPrefix = brand.label.toUpperCase();
//         allModelsList = allModelsList.filter(model =>
//           model.carModelName.toUpperCase().startsWith(brandPrefix)
//         );
//       }

//       setModels(allModelsList);
//     } else {
//       setModels([]);
//     }
//   } catch (error) {
//     console.error("Error fetching models:", error);
//     setModels([]);
//   } finally {
//     setIsModelsLoading(false);
//   }
// }, [selectedCategory, selectedBrand]);
const fetchAllModels = useCallback(async (categoryToUse = null, brandToUse = null) => {
  setIsModelsLoading(true);
  setModels([]);
  try {
    const category = categoryToUse || selectedCategory;
    const brand = brandToUse || selectedBrand;

    const params = {
      ...(category?.label && { categoryName: category.label }),
      ...(brand?.label && { brandName: brand.label }),
      page: 0,
      size: 20,
    };

    const response = await axios.get(
      'https://car.amar.co.jp/api/dashboard/filter/advance-filter-new',
      {
        params,
        headers: { Accept: "application/json", "Accept-Language": "en" },
      }
    );

    const data = response.data;

    if (data.carModelNames && Array.isArray(data.carModelNames)) {
      const uniqueModels = data.carModelNames
        .filter(Boolean)
        .map(modelName => ({ carModelName: formatModelName(modelName) }));
      setModels(uniqueModels);
    } else {
      setModels([]);
    }
    // ✅ setModelsFetched NAHI — MoreFilterDialog mein ye state exist nahi karti
  } catch (error) {
    console.error("Error fetching models:", error);
    setModels([]);
    // ✅ setModelsFetched NAHI
  } finally {
    setIsModelsLoading(false);
  }
}, [selectedCategory, selectedBrand]);


  // FIXED: fetchAllYears now accepts category, brand and models parameters
  // const fetchAllYears = useCallback(async (categoryToUse = null, brandToUse = null, modelsToUse = null) => {
  //   try {
  //     const category = categoryToUse || selectedCategory;
  //     const brand = brandToUse || selectedBrand;
  //     const modelsArray = modelsToUse || selectedModels;
      
  //     const hasFilters = category || brand || modelsArray.length > 0;
  //     if (hasFilters) {
  //       const params = { 
  //         categoryName: category?.label || "", 
  //         brandName: brand?.label || "", 
  //         modelNames: modelsArray.map(model => model.carModelName), 
  //         page: '0', 
  //         size: '100' 
  //       };
  //       const response = await axios.get('https://car.amar.co.jp/api/dashboard/filter/advance-filter-new', { 
  //         params: params, 
  //         headers: { Accept: "application/json", "Accept-Language": "en" }, 
  //         paramsSerializer: p => qs.stringify(p, { arrayFormat: 'repeat' }) 
  //       });
  //       const data = response.data;
  //       if (data.data && Array.isArray(data.data)) {
  //         const yearList = Array.from(
  //           new Set(data.data.map(item => item.year).filter(Boolean))
  //         ).map(year => ({ year: parseInt(year) })).sort((a, b) => b.year - a.year);
  //         setYears(yearList);
  //       } else {
  //          const currentYear = new Date().getFullYear();
  //          const initialYears = Array.from({ length: 16 }, (_, i) => ({ year: currentYear - i }));
  //          setYears(initialYears);
  //       }
  //     } else {
  //       const currentYear = new Date().getFullYear();
  //       const initialYears = Array.from({ length: 16 }, (_, i) => ({ year: currentYear - i }));
  //       setYears(initialYears);
  //     }
  //   } catch (error) { 
  //     console.error("Error fetching years:", error); 
  //   }
  // }, [selectedCategory, selectedBrand, selectedModels]);
  const fetchAllYears = useCallback(async (categoryToUse = null, brandToUse = null, modelsToUse = null) => {
  setIsYearsLoading(true);
  setYears([]); // ✅ Pehle clear karo
  try {
    const category = categoryToUse || selectedCategory;
    const brand = brandToUse || selectedBrand;
    const modelsArray = modelsToUse || selectedModels;
    const hasFilters = category || brand || modelsArray.length > 0;

    if (hasFilters) {
      const params = {
        categoryName: category?.label || "",
        brandName: brand?.label || "",
        modelNames: modelsArray.map(model => model.carModelName),
        page: '0',
        size: '100'
      };
      const response = await axios.get('https://car.amar.co.jp/api/dashboard/filter/advance-filter-new', {
        params,
        headers: { Accept: "application/json", "Accept-Language": "en" },
        paramsSerializer: p => qs.stringify(p, { arrayFormat: 'repeat' })
      });
      const data = response.data;
      if (data.data && Array.isArray(data.data)) {
        const yearList = Array.from(
          new Set(data.data.map(item => item.year).filter(Boolean))
        ).map(year => ({ year: parseInt(year) })).sort((a, b) => b.year - a.year);
        setYears(yearList);
      } else {
        const currentYear = new Date().getFullYear();
        setYears(Array.from({ length: 16 }, (_, i) => ({ year: currentYear - i })));
      }
    // } else {
    //   const currentYear = new Date().getFullYear();
    //   setYears(Array.from({ length: 16 }, (_, i) => ({ year: currentYear - i })));
    // }
    } else {
  const response = await axios.get(
    'https://car.amar.co.jp/api/master/car-model/get/unique/years',
    { headers: { Accept: "application/json", "Accept-Language": "en" } }
  );
  if (response.data?.data && Array.isArray(response.data.data)) {
    const allYearsList = response.data.data
      .map(item => ({ year: parseInt(item.year) }))
      .filter(y => !isNaN(y.year) && y.year > 0)
      .sort((a, b) => b.year - a.year);
    setYears(allYearsList);
  } else {
    const currentYear = new Date().getFullYear();
    setYears(Array.from({ length: 16 }, (_, i) => ({ year: currentYear - i })));
  }
}
setYearsFetched(true);
    setYearsFetched(true);
  } catch (error) {
    console.error("Error fetching years:", error);
  } finally {
    setIsYearsLoading(false); // ✅
  }
}, [selectedCategory, selectedBrand, selectedModels]);

  // FIXED: useEffect to fetch brands when category changes
  useEffect(() => {
    if (open) {
      fetchAllBrands(selectedCategory);
    }
  }, [open, selectedCategory]);

  // FIXED: useEffect to fetch models when category or brand changes
  // useEffect(() => {
  //   if (open) {
  //     fetchAllModels(selectedCategory, selectedBrand);
  //   }
  // }, [open, selectedCategory, selectedBrand]);
  // useEffect(() => {
  //   if (open) {
  //     const brand = initialFilters.selectedBrand || 
  //       (initialFilters.brandName ? { label: initialFilters.brandName } : null);
  //     const category = initialFilters.selectedCategory || 
  //       (initialFilters.categoryName ? { label: initialFilters.categoryName } : null);
      
  //     fetchAllModels(category, brand);
  //   }
  // }, [open, initialFilters.brandName, initialFilters.selectedBrand?.label]);
  useEffect(() => {
    if (open) {
      fetchAllModels(selectedCategory, selectedBrand);
    }
  }, [open, selectedCategory, selectedBrand]);

  // FIXED: useEffect to fetch years when category, brand or models change
  useEffect(() => {
    if (open) {
      fetchAllYears(selectedCategory, selectedBrand, selectedModels);
    }
  }, [open, selectedCategory, selectedBrand, selectedModels]);

  // Initialize data on dialog open
  useEffect(() => {
    if (open) {
      fetchAllCategories();
      fetchAllOptions();
    }
  }, [open]);

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleAccessoryToggle = (key) => {
    setFilters((prev) => ({
      ...prev,
      carFilterAccessories: Array.isArray(prev.carFilterAccessories) 
        ? (prev.carFilterAccessories.includes(key)
            ? prev.carFilterAccessories.filter((i) => i !== key)
            : [...prev.carFilterAccessories, key])
        : [key] 
    }));
  };

  const handleColorSelect = (color) => {
    setFilters((prev) => ({ 
      ...prev, 
      colorSelect: prev.colorSelect === color ? "" : color 
    }));
  };

  const resetFilters = () => {
    setSelectedCategory(null);
    setSelectedBrand(null);
    setSelectedModels([]);
    setSelectedYears([]);
    
    setFilters((prev) => ({
      ...prev,
      colorSelect: '',
      carDriveType: '',
      carEngine: '',
      carFilterAccessories: [],
      carFuelType: '',
      carMileage: '',
      carPrice: '',
      carSeat: '',
      carSteering: '',
      carTransmission: ''
    }));
    
    setFilteredTotalItems(currentData?.totalItems || 0);

    // BasicSelectFilter to reset its state
    onApplyFilters?.({
      selectedCategory: null,
      selectedBrand: null,
      selectedModels: [],
      selectedYears: [],
      categoryName: '',
      brandName: '',
      modelNames: [],
      years: [],
      colorSelect: '',
      carDriveType: '',
      carEngine: '',
      carFilterAccessories: [],
      carFuelType: '',
      carMileage: '',
      carPrice: '',
      carSeat: '',
      carSteering: '',
      carTransmission: '',
    });
  };

  const getSelectedCount = () => {
    let count = 0;
    
    if (selectedCategory) count++;
    if (selectedBrand) count++;
    if (selectedModels.length > 0) count += selectedModels.length;
    if (selectedYears.length > 0) count += selectedYears.length;

    [
      "colorSelect", "carDriveType", "carEngine", "carFuelType", 
      "carMileage", "carPrice", "carSeat", "carSteering", "carTransmission"
    ].forEach((k) => {
      if (filters[k] && `${filters[k]}`.trim() !== "") count++;
    });

    if (Array.isArray(filters.carFilterAccessories)) {
      count += filters.carFilterAccessories.filter(Boolean).length;
    }
    
    return count;
  };

  const buildApiParams = useCallback((baseFilters) => {
    const p = { ...baseFilters };
    Object.keys(p).forEach((k) => {
      const v = p[k];
      if (v === "" || v === null || v === undefined || (Array.isArray(v) && v.length === 0)) delete p[k];
    });
    return p;
  }, []);

  const handleShowCars = useCallback(() => {
    const navParams = buildApiParams({
      categoryName: selectedCategory?.label || '',
      brandName: selectedBrand?.label || '',
      modelNames: selectedModels.map(m => m.carModelName),
      years: selectedYears.map(y => y.year),
      
      colorSelect: filters.colorSelect, 
      carDriveType: filters.carDriveType, 
      carEngine: filters.carEngine,
      carFilterAccessories: Array.isArray(filters.carFilterAccessories) ? filters.carFilterAccessories : [], 
      carFuelType: filters.carFuelType,
      carMileage: filters.carMileage, 
      carPrice: filters.carPrice, 
      carSeat: filters.carSeat,
      carSteering: filters.carSteering, 
      carTransmission: filters.carTransmission,
      
      page: 1, 
      size: 20,
    });

    const completeFilterState = {
      // Object form for component use
      selectedCategory: selectedCategory,
      selectedBrand: selectedBrand,
      selectedModels: selectedModels,
      selectedYears: selectedYears,
      
      // String form for API use
      categoryName: selectedCategory?.label || "",
      brandName: selectedBrand?.label || "",
      modelNames: selectedModels.map(m => m.carModelName),
      years: selectedYears.map(y => y.year),
      
      // Other filters
      colorSelect: filters.colorSelect || "", 
      carDriveType: filters.carDriveType || "", 
      carEngine: filters.carEngine || "",
      carFilterAccessories: Array.isArray(filters.carFilterAccessories) ? filters.carFilterAccessories : [], 
      carFuelType: filters.carFuelType || "",
      carMileage: filters.carMileage || "", 
      carPrice: filters.carPrice || "", 
      carSeat: filters.carSeat || "",
      carSteering: filters.carSteering || "", 
      carTransmission: filters.carTransmission || "",
    };
    
    const searchString = qs.stringify(navParams, { arrayFormat: "repeat", encode: false });

    navigate(
      { 
        pathname: "/FilterByGlobalSearch", 
        search: `?${searchString}` 
      },
      { 
        state: { 
          filterState: completeFilterState, 
          totalItems: filteredTotalItems, 
          key: Date.now(),
        } 
      }
    );

    onApplyFilters?.(completeFilterState);
    onClose?.();
  }, [filters, selectedCategory, selectedBrand, selectedModels, selectedYears, buildApiParams, navigate, filteredTotalItems, onClose, onApplyFilters]);

  const extractValueFromObject = (item, keyPatterns) => {
    if (typeof item === 'string') return item;
    if (typeof item !== 'object' || item === null) return String(item);
    
    for (const pattern of keyPatterns) {
      if (item[pattern] !== undefined) { return item[pattern]; }
    }
    for (const key in item) {
      if (typeof item[key] === 'string') { return item[key]; }
    }
    return String(item);
  };

  const fetchAllOptions = useCallback(async () => {
    setLoading(true);
    try {
      const endpoints = [
        { url: 'https://car.amar.co.jp/api/dashboard/car-color/get-all-color', key: 'colors', extractPatterns: ['carColorName', 'carColor', 'colorName', 'color'] },
        { url: 'https://car.amar.co.jp/api/dashboard/car-drive-type/get-all-drive-type', key: 'driveTypes', extractPatterns: ['carDriveType', 'driveType', 'type'] },
        { url: 'https://car.amar.co.jp/api/dashboard/car-engine/get-all-engine-cc-range', key: 'engines', extractPatterns: ['carEngineCCRange', 'engineRange', 'engine'] },
        { url: 'https://car.amar.co.jp/api/dashboard/car-filter-accessories/get-all-filter-accessories', key: 'accessories', extractPatterns: ['carFilterAccessories', 'accessory', 'name'] },
        { url: 'https://car.amar.co.jp/api/dashboard/car-fuel-type/get-all-fuel-type', key: 'fuelTypes', extractPatterns: ['carFuelType', 'fuelType', 'type'] },
        { url: 'https://car.amar.co.jp/api/dashboard/car-mileage/get-all-mileage-range', key: 'mileages', extractPatterns: ['carMileageRange', 'mileageRange', 'mileage'] },
        { url: 'https://car.amar.co.jp/api/dashboard/car-price/get-all-price-range', key: 'prices', extractPatterns: ['carPriceRange', 'priceRange', 'price'] },
        { url: 'https://car.amar.co.jp/api/dashboard/car-seat/get-all-seat', key: 'seats', extractPatterns: ['carSeat', 'seat', 'seats'] },
        { url: 'https://car.amar.co.jp/api/dashboard/car-steering/get-all-steering-type', key: 'steerings', extractPatterns: ['carSteering', 'steering', 'type'] },
        { url: 'https://car.amar.co.jp/api/dashboard/car-transmission/get-all-transmission-type', key: 'transmissions', extractPatterns: ['carTransmission', 'transmission', 'type'] }
      ];

      const requests = endpoints.map(endpoint => 
        axios.get(endpoint.url, { headers: { 'Accept-Language': 'en', 'accept': 'application/json' } })
        .then(response => ({ key: endpoint.key, data: response.data, extractPatterns: endpoint.extractPatterns }))
      );

      const results = await Promise.all(requests);
      
      const options = {};
      results.forEach(result => {
        let dataArray = (result.data && result.data.data) || (Array.isArray(result.data) ? result.data : []);
        options[result.key] = dataArray.map(item => extractValueFromObject(item, result.extractPatterns));
      });
      
      if (options.accessories && Array.isArray(options.accessories)) {
        options.accessories = options.accessories.map(acc => ({
          carFilterAccessories: acc,
          displayName: typeof acc === 'string' ? acc.replace(/_/g, ' ').toUpperCase().replace(/\b\w/g, l => l.toUpperCase()) : String(acc)
        }));
      }
      
      if (options.colors && Array.isArray(options.colors)) {
        options.colors = options.colors.map(color => ({
          carColor: color,
          displayName: typeof color === 'string' ? color.charAt(0) + color.slice(1).toLowerCase() : String(color)
        }));
      }
      
      setAllOptions(options);
    } catch (error) {
      console.error('Error fetching options:', error);
      setAllOptions(prev => ({ ...prev, colors: [], driveTypes: [], engines: [], accessories: [], fuelTypes: [], mileages: [], prices: [], seats: [], steerings: [], transmissions: [] }));
    } finally {
      setLoading(false);
    }
  }, []);

  // Debounced filter count update
  useEffect(() => {
    if (!open) return;
    
    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(async () => {
      try {
        const apiParams = {
          categoryName: selectedCategory?.label || '',
          brandName: selectedBrand?.label || '',
          modelNames: selectedModels.map(m => m.carModelName),
          years: selectedYears.map(y => y.year),
          colorSelect: filters.colorSelect, 
          carDriveType: filters.carDriveType, 
          carEngine: filters.carEngine,
          carFilterAccessories: Array.isArray(filters.carFilterAccessories) ? filters.carFilterAccessories : [], 
          carFuelType: filters.carFuelType,
          carMileage: filters.carMileage, 
          carPrice: filters.carPrice, 
          carSeat: filters.carSeat,
          carSteering: filters.carSteering, 
          carTransmission: filters.carTransmission,
          page: 0,
          size: 1,
        };

        // Remove empty values
        Object.keys(apiParams).forEach(key => {
          const value = apiParams[key];
          if (value === '' || value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
            delete apiParams[key];
          }
        });

        const res = await axios.get(
          "https://car.amar.co.jp/api/dashboard/filter/advance-filter-new",
          {
            params: apiParams,
            paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "repeat" }),
            headers: { "Accept-Language": "en", accept: "application/json" },
          }
        );

        setFilteredTotalItems(res.data?.totalItems || res.data?.pageInfo?.totalItems || 0);
      } catch (err) {
        console.error("Error fetching filtered count:", err);
        setFilteredTotalItems(0);
      }
    }, 500);

    return () => clearTimeout(debounceRef.current);
  }, [open, selectedCategory, selectedBrand, selectedModels, selectedYears, filters]);

  useEffect(() => {
    if (open) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = prev;
      };
    }
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  useEffect(() => {
  if (!open) return;
  const handleClickOutside = (e) => {
    if (bodyTypeRef.current && !bodyTypeRef.current.contains(e.target)) {
      setIsBodyTypeOpen(false);
    }
    if (brandRef.current && !brandRef.current.contains(e.target)) {
      setIsBrandOpen(false);
    }
    if (modelRef.current && !modelRef.current.contains(e.target)) {
      setIsModelOpen(false);
    }
    if (yearRef.current && !yearRef.current.contains(e.target)) {
      setIsYearOpen(false);
    }
  };
  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, [open]);

  if (!open) return null;

  const DropdownLoader = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "40px 20px",
      gap: 2,
    }}
  >
    <Box
      component="img"
      src="/image/footer-logo-small.svg"
      alt="Loading..."
      sx={{ width: 50, height: 50 }}
    />
    <Typography sx={{ color: "#666", fontSize: "13px" }}>Loading...</Typography>
  </Box>
);


  return createPortal(
    <div className="mfd-overlay" ref={overlayRef} role="presentation" onClick={onClose}>
      <div 
        className="mfd-modal" 
        role="dialog" 
        aria-modal="true" 
        onClick={(e) => e.stopPropagation()}
      >
        <button 
          className="mfd-close" 
          aria-label="Close filters" 
          onClick={onClose}
        >
          <CloseIcon fontSize="medium" />
        </button>

        {/* Top Selection Row: Body Type, Brand, Models, Years */}
        {/* <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: "12px",
          padding: "20px 0px",
          marginBottom: "10px"
        }}> */}
        <div className="mfd-top-grid" style={{
              gap: "12px",
              padding: "20px 0px",
              marginBottom: "10px"
            }}>
          {/* Body Type Custom Dropdown */}
          <div style={{ position: 'relative' }} ref={bodyTypeRef}>
            <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block', fontSize: '12px' }}>Body Type</label>
            <button
              onClick={() => setIsBodyTypeOpen(!isBodyTypeOpen)}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                backgroundColor: '#fff',
                textAlign: 'left',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              {selectedCategory?.label || 'Select Body Type'}
            </button>
            {isBodyTypeOpen && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                borderRadius: '4px',
                maxHeight: '250px',
                overflowY: 'auto',
                zIndex: 1000,
                marginTop: '5px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }}>
                {isCategoriesLoading ? (
                  <DropdownLoader />
                ) : (
                  bodyTypes.map((type, idx) => (
                    <div
                      key={idx}
                      onClick={() => {
                        setSelectedCategory(type);
                        setIsBodyTypeOpen(false);
                        setSelectedBrand(null);
                        setSelectedModels([]);
                        setSelectedYears([]);
                      }}
                      style={{
                        padding: '10px 12px', cursor: 'pointer', borderBottom: '1px solid #eee',
                        backgroundColor: selectedCategory?.label === type.label ? '#f0f0f0' : '#fff',
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box component="img" src={type.src} alt={type.label} sx={{ width: 18, height: 18 }} />
                        <span>{type.label}</span>
                      </Box>
                    </div>
                  ))
                )}
              </div>
            )}
          </div>

          {/* Brand Custom Dropdown */}
          <div style={{ position: 'relative' }} ref={brandRef}>
            <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block', fontSize: '12px' }}>Brand</label>
            <button
              onClick={() => setIsBrandOpen(!isBrandOpen)}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                backgroundColor: '#fff',
                textAlign: 'left',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              {selectedBrand?.label || 'Select Brand'}
            </button>
            {/* {isBrandOpen && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                borderRadius: '4px',
                maxHeight: '250px',
                overflowY: 'auto',
                zIndex: 1000,
                marginTop: '5px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }}>
                {brands.length > 0 ? brands.map((brand, idx) => (
                  <div
                    key={idx}
                    onClick={() => {
                      setSelectedBrand({ label: brand.carBrandName });
                      setIsBrandOpen(false);
                      // FIXED: Reset dependent fields
                      setSelectedModels([]);
                      setSelectedYears([]);
                      // REMOVED: Direct fetchAllModels() call - useEffect will handle it
                    }}
                    style={{
                      padding: '10px 12px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #eee',
                      backgroundColor: selectedBrand?.label === brand.carBrandName ? '#f0f0f0' : '#fff',
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = selectedBrand?.label === brand.carBrandName ? '#f0f0f0' : '#fff'}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Box component="img" src={getBrandImage(brand.carBrandName)} alt={brand.carBrandName} sx={{ width: 18, height: 18 }} />
                      <span>{brand.carBrandName}</span>
                    </Box>
                  </div>
                )) : (
                  <div style={{ padding: '10px 12px', color: '#999', textAlign: 'center' }}>
                    {selectedCategory ? 'No brands found for this body type' : 'Select a body type first or loading...'}
                  </div>
                )}
              </div>
            )} */}

            {/* {isBrandOpen && (
              <div style={{
                position: 'absolute', top: '100%', left: 0, right: 0,
                backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px',
                maxHeight: '250px', overflowY: 'auto', zIndex: 1000,
                marginTop: '5px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }}>
                {isBrandsLoading ? (
                  <DropdownLoader />
                ) : brands.length > 0 ? brands.map((brand, idx) => (
                  <div
                    key={idx}
                    onClick={() => {
                      setSelectedBrand({ label: brand.carBrandName });
                      setIsBrandOpen(false);
                      setSelectedModels([]);
                      setSelectedYears([]);
                    }}
                    style={{
                      padding: '10px 12px', cursor: 'pointer', borderBottom: '1px solid #eee',
                      backgroundColor: selectedBrand?.label === brand.carBrandName ? '#f0f0f0' : '#fff',
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Box component="img" src={getBrandImage(brand.carBrandName)} alt={brand.carBrandName} sx={{ width: 18, height: 18 }} />
                      <span>{brand.carBrandName}</span>
                    </Box>
                  </div>
                )) : (
                  <div style={{ padding: '10px 12px', color: '#999', textAlign: 'center' }}>
                    No brands found
                  </div>
                )}
              </div>
            )} */}

            {isBrandOpen && (
              <div style={{
                position: 'absolute', top: '100%', left: 0, right: 0,
                backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px',
                maxHeight: '250px', overflowY: 'auto', zIndex: 1000,
                marginTop: '5px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }}>
                {isBrandsLoading ? (
                  <DropdownLoader />
                ) : brands.length > 0 ? brands.map((brand, idx) => (
                  <div
                    key={idx}
                    onClick={() => {
                      setSelectedBrand({ label: brand.carBrandName });
                      setIsBrandOpen(false);
                      setSelectedModels([]);
                      setSelectedYears([]);
                    }}
                    style={{
                      padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #eee',
                      backgroundColor: selectedBrand?.label === brand.carBrandName ? '#fff5f5' : '#fff',
                      display: 'flex', alignItems: 'center', gap: '10px'
                    }}
                  >
                    {/* Radio Button */}
                    <div style={{
                      width: 16,
                      height: 16,
                      border: selectedBrand?.label === brand.carBrandName ? '2px solid #E9242A' : '2px solid #d0d0d0',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                      backgroundColor: '#fff',
                      transition: 'all 0.2s',
                    }}>
                      {selectedBrand?.label === brand.carBrandName && (
                        <div style={{
                          width: 8,
                          height: 8,
                          borderRadius: '50%',
                          backgroundColor: '#E9242A',
                        }} />
                      )}
                    </div>
                    <span style={{
                      fontSize: '13px',
                      fontWeight: selectedBrand?.label === brand.carBrandName ? 600 : 400,
                      color: selectedBrand?.label === brand.carBrandName ? '#E9242A' : '#333',
                    }}>
                      {brand.carBrandName}
                    </span>
                  </div>
                )) : (
                  <div style={{ padding: '10px 12px', color: '#999', textAlign: 'center' }}>
                    No brands found
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Models Custom Dropdown */}
          {/* <div style={{ position: 'relative' }}>
            <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block', fontSize: '12px' }}>Models</label>
            <button
              onClick={() => setIsModelOpen(!isModelOpen)}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                backgroundColor: '#fff',
                textAlign: 'left',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              {selectedModels.length === 0 ? 'Select Models' : `${selectedModels.length} selected`}
            </button>
            {isModelOpen && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                borderRadius: '4px',
                maxHeight: '250px',
                overflowY: 'auto',
                zIndex: 1000,
                marginTop: '5px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }}>
                {models.length > 0 ? models.map((model, idx) => (
                  <label
                    key={idx}
                    style={{
                      padding: '10px 12px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #eee',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedModels.some(m => m.carModelName === model.carModelName)}
                      onChange={() => {
                        const isSelected = selectedModels.some(m => m.carModelName === model.carModelName);
                        if (isSelected) {
                          setSelectedModels(selectedModels.filter(m => m.carModelName !== model.carModelName));
                        } else {
                          setSelectedModels([...selectedModels, model]);
                        }
                        // FIXED: Reset years when models change
                        setSelectedYears([]);
                        // REMOVED: Direct fetchAllYears() call - useEffect will handle it
                      }}
                    />
                    <span>{model.carModelName}</span>
                  </label>
                )) : (
                  <div style={{ padding: '10px 12px', color: '#999', textAlign: 'center' }}>
                    {selectedBrand ? 'No models found for this brand' : 'Select a brand first or loading...'}
                  </div>
                )}
              </div>
            )}
          </div> */}
          {/* <div style={{ position: 'relative' }}>
            <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block', fontSize: '12px' }}>Models</label>
            <button
              onClick={() => setIsModelOpen(!isModelOpen)}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                backgroundColor: '#fff',
                textAlign: 'left',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              {selectedModels.length === 0 ? 'Select Model' : selectedModels[0]?.carModelName}
            </button>
            {isModelOpen && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                borderRadius: '4px',
                maxHeight: '250px',
                overflowY: 'auto',
                zIndex: 1000,
                marginTop: '5px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }}>
                {models.length > 0 ? models.map((model, idx) => (
                  <div
                    key={idx}
                    onClick={() => {
                      const isSelected = selectedModels.some(m => m.carModelName === model.carModelName);
                      if (isSelected) {
                        setSelectedModels([]);
                      } else {
                        setSelectedModels([model]);
                      }
                      setSelectedYears([]);
                      setIsModelOpen(false);
                    }}
                    style={{
                      padding: '10px 12px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #eee',
                      backgroundColor: selectedModels.some(m => m.carModelName === model.carModelName) ? '#f0f0f0' : '#fff',
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = selectedModels.some(m => m.carModelName === model.carModelName) ? '#f0f0f0' : '#fff'}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <span>{model.carModelName}</span>
                    </Box>
                  </div>
                )) : (
                  <div style={{ padding: '10px 12px', color: '#999', textAlign: 'center' }}>
                    {selectedBrand ? 'No models found for this brand' : 'Select a brand first or loading...'}
                  </div>
                )}
              </div>
            )}
          </div> */}
          <div style={{ position: 'relative' }} ref={modelRef}>
            <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block', fontSize: '12px' }}>Models</label>
            <button
              onClick={() => {
                if (!selectedBrand) {
                  setIsBrandOpen(true);  // ✅ Brand dropdown kholo
                  setIsModelOpen(false); // ✅ Model band rakho
                  return;
                }
                setIsModelOpen(!isModelOpen);
              }}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                backgroundColor: !selectedBrand ? '#f9f9f9' : '#fff', // ✅ Disabled look
                textAlign: 'left',
                cursor: !selectedBrand ? 'not-allowed' : 'pointer',   // ✅ Cursor change
                fontSize: '14px',
                color: !selectedBrand ? '#aaa' : '#000',              // ✅ Text color hint
              }}
            >
              {!selectedBrand
                ? 'Select Brand First'         // ✅ Hint text
                : selectedModels.length === 0
                  ? 'Select Model'
                  : selectedModels[0]?.carModelName
              }
            </button>
            {/* {isModelOpen && selectedBrand && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                borderRadius: '4px',
                maxHeight: '250px',
                overflowY: 'auto',
                zIndex: 1000,
                marginTop: '5px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }}>
                {models.length > 0 ? models.map((model, idx) => (
                  <div
                    key={idx}
                    onClick={() => {
                      const isSelected = selectedModels.some(m => m.carModelName === model.carModelName);
                      if (isSelected) {
                        setSelectedModels([]);
                      } else {
                        setSelectedModels([model]);
                      }
                      setSelectedYears([]);
                      setIsModelOpen(false);
                    }}
                    style={{
                      padding: '10px 12px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #eee',
                      backgroundColor: selectedModels.some(m => m.carModelName === model.carModelName) ? '#f0f0f0' : '#fff',
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = selectedModels.some(m => m.carModelName === model.carModelName) ? '#f0f0f0' : '#fff'}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <span>{model.carModelName}</span>
                    </Box>
                  </div>
                )) : (
                  <div style={{ padding: '10px 12px', color: '#999', textAlign: 'center' }}>
                    No models found for this brand
                  </div>
                )}
              </div>
            )} */}

            {/* {isModelOpen && selectedBrand && (
              <div style={{
                position: 'absolute', top: '100%', left: 0, right: 0,
                backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px',
                maxHeight: '250px', overflowY: 'auto', zIndex: 1000,
                marginTop: '5px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }}>
                {isModelsLoading ? (
                  <DropdownLoader />
                ) : models.length > 0 ? models.map((model, idx) => (
                  <div
                    key={idx}
                    onClick={() => {
                      const isSelected = selectedModels.some(m => m.carModelName === model.carModelName);
                      setSelectedModels(isSelected ? [] : [model]);
                      setSelectedYears([]);
                      setIsModelOpen(false);
                    }}
                    style={{
                      padding: '10px 12px', cursor: 'pointer', borderBottom: '1px solid #eee',
                      backgroundColor: selectedModels.some(m => m.carModelName === model.carModelName) ? '#f0f0f0' : '#fff',
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <span>{model.carModelName}</span>
                    </Box>
                  </div>
                )) : (
                  <div style={{ padding: '10px 12px', color: '#999', textAlign: 'center' }}>
                    No models found for this brand
                  </div>
                )}
              </div>
            )} */}

            {isModelOpen && selectedBrand && (
            <div style={{
              position: 'absolute', top: '100%', left: 0, right: 0,
              backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px',
              maxHeight: '250px', overflowY: 'auto', zIndex: 1000,
              marginTop: '5px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            }}>
              {isModelsLoading ? (
                <DropdownLoader />
              ) : models.length > 0 ? models.map((model, idx) => (
                <div
                  key={idx}
                  onClick={() => {
                    const isSelected = selectedModels.some(m => m.carModelName === model.carModelName);
                    setSelectedModels(isSelected ? [] : [model]);
                    setSelectedYears([]);
                    setIsModelOpen(false);
                  }}
                  style={{
                    padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #eee',
                    backgroundColor: selectedModels.some(m => m.carModelName === model.carModelName) ? '#fff5f5' : '#fff',
                    display: 'flex', alignItems: 'center', gap: '10px'
                  }}
                >
                  {/* Radio Button */}
                  <div style={{
                    width: 16,
                    height: 16,
                    border: selectedModels.some(m => m.carModelName === model.carModelName) ? '2px solid #E9242A' : '2px solid #d0d0d0',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    backgroundColor: '#fff',
                    transition: 'all 0.2s',
                  }}>
                    {selectedModels.some(m => m.carModelName === model.carModelName) && (
                      <div style={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: '#E9242A',
                      }} />
                    )}
                  </div>
                  <span style={{
                    fontSize: '13px',
                    fontWeight: selectedModels.some(m => m.carModelName === model.carModelName) ? 600 : 400,
                    color: selectedModels.some(m => m.carModelName === model.carModelName) ? '#E9242A' : '#333',
                  }}>
                    {model.carModelName}
                  </span>
                </div>
              )) : (
                <div style={{ padding: '10px 12px', color: '#999', textAlign: 'center' }}>
                  No models found for this brand
                </div>
              )}
            </div>
          )}
          </div>

          {/* Years Custom Dropdown */}
          <div style={{ position: 'relative' }} ref={yearRef}>
            <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block', fontSize: '12px' }}>Years</label>
            <button
              onClick={() => setIsYearOpen(!isYearOpen)}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                backgroundColor: '#fff',
                textAlign: 'left',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              {selectedYears.length === 0 ? 'Select Years' : `${selectedYears.length} selected`}
            </button>
            {/* {isYearOpen && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                borderRadius: '4px',
                maxHeight: '250px',
                overflowY: 'auto',
                zIndex: 1000,
                marginTop: '5px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }}>
                {years.length > 0 ? years.map((year, idx) => (
                  <label
                    key={idx}
                    style={{
                      padding: '10px 12px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #eee',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedYears.some(y => y.year === year.year)}
                      onChange={() => {
                        const isSelected = selectedYears.some(y => y.year === year.year);
                        if (isSelected) {
                          setSelectedYears(selectedYears.filter(y => y.year !== year.year));
                        } else {
                          setSelectedYears([...selectedYears, year]);
                        }
                      }}
                    />
                    <span>{year.year}</span>
                  </label>
                )) : (
                  <div style={{ padding: '10px 12px', color: '#999', textAlign: 'center' }}>
                    {(selectedCategory || selectedBrand || selectedModels.length > 0) ? 'No years found' : 'Loading years...'}
                  </div>
                )}
              </div>
            )} */}
            {isYearOpen && (
              <div style={{
                position: 'absolute', top: '100%', left: 0, right: 0,
                backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px',
                maxHeight: '250px', overflowY: 'auto', zIndex: 1000,
                marginTop: '5px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }}>
                {isYearsLoading ? (
                  <DropdownLoader />
                ) : years.length > 0 ? years.map((year, idx) => (
                  <label
                    key={idx}
                    style={{
                      padding: '10px 12px', cursor: 'pointer', borderBottom: '1px solid #eee',
                      display: 'flex', alignItems: 'center', gap: '8px'
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedYears.some(y => y.year === year.year)}
                      onChange={() => {
                        const isSelected = selectedYears.some(y => y.year === year.year);
                        setSelectedYears(isSelected
                          ? selectedYears.filter(y => y.year !== year.year)
                          : [...selectedYears, year]
                        );
                      }}
                    />
                    <span>{year.year}</span>
                  </label>
                )) : (
                  <div style={{ padding: '10px 12px', color: '#999', textAlign: 'center' }}>
                    No years found
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Rest of filters sections */}
        <div className="mfd-grid">
          {allOptions.mileages.length > 0 && (
            <div className="mfd-section">
              <label className="mfd-label">Mileage</label>
              <select 
                className="mfd-select" 
                value={filters.carMileage} 
                onChange={(e) => handleFilterChange("carMileage", e.target.value)}
              >
                <option value="">Select Mileage</option>
                {allOptions.mileages.map((m, i) => (
                  <option key={i} value={m}>{m}</option>
                ))}
              </select>
            </div>
          )}

          {allOptions.engines.length > 0 && (
            <div className="mfd-section">
              <label className="mfd-label">Engine</label>
              <select 
                className="mfd-select" 
                value={filters.carEngine} 
                onChange={(e) => handleFilterChange("carEngine", e.target.value)}
              >
                <option value="">Select Engine</option>
                {allOptions.engines.map((eng, i) => (
                  <option key={i} value={eng}>{eng}</option>
                ))}
              </select>
            </div>
          )}

          {allOptions.seats.length > 0 && (
            <div className="mfd-section">
              <label className="mfd-label">Seats</label>
              <select 
                className="mfd-select" 
                value={filters.carSeat} 
                onChange={(e) => handleFilterChange("carSeat", e.target.value)}
              >
                <option value="">Select Seats</option>
                {allOptions.seats.map((s, i) => (
                  <option key={i} value={s}>{s}</option>
                ))}
              </select>
            </div>
          )}

          {allOptions.driveTypes.length > 0 && (
            <div className="mfd-section">
              <label className="mfd-label">Drive Type</label>
              <select 
                className="mfd-select" 
                value={filters.carDriveType} 
                onChange={(e) => handleFilterChange("carDriveType", e.target.value)}
              >
                <option value="">Select Drive Type</option>
                {allOptions.driveTypes.map((d, i) => (
                  <option key={i} value={d}>{d}</option>
                ))}
              </select>
            </div>
          )}

          {allOptions.fuelTypes.length > 0 && (
            <div className="mfd-section">
              <label className="mfd-label">Fuel Type</label>
              <select 
                className="mfd-select" 
                value={filters.carFuelType} 
                onChange={(e) => handleFilterChange("carFuelType", e.target.value)}
              >
                <option value="">Select Fuel Type</option>
                {allOptions.fuelTypes.map((f, i) => (
                  <option key={i} value={f}>{f}</option>
                ))}
              </select>
            </div>
          )}
        </div>

        <div className="mfd-grid">
          {allOptions.colors.length > 0 && (
            <div>
              <h3 className="mfd-heading">Popular Color</h3>
              <div className="mfd-scroll">
                <div className="mfd-colors-grid">
                  {allOptions.colors.map((c) => {
                    const clr = COLOR_MAP[c.carColor] || "#CCCCCC";
                    const selected = filters.colorSelect === c.carColor;
                    return (
                      <div key={c.carColor} className="mfd-color-wrap">
                        <button
                          type="button"
                          className={`mfd-color-btn ${selected ? "selected" : ""}`}
                          onClick={() => handleColorSelect(c.carColor)}
                          style={{ 
                            backgroundColor: clr, 
                            border: c.carColor === "WHITE" && !selected ? "1px solid #ddd" : undefined 
                          }}
                          title={c.displayName}
                        />
                        <div className="mfd-color-name">{c.displayName}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}

          {allOptions.accessories.length > 0 && (
            <div>
              <h3 className="mfd-heading">Accessories</h3>
              <div className="mfd-scroll accessory-list">
                {allOptions.accessories.map((a) => (
                  <label key={a.carFilterAccessories} className="mfd-checkbox-label">
                    <input 
                      type="checkbox" 
                      checked={Array.isArray(filters.carFilterAccessories) 
                        ? filters.carFilterAccessories.includes(a.carFilterAccessories)
                        : false
                      } 
                      onChange={() => handleAccessoryToggle(a.carFilterAccessories)} 
                    />
                    <span>{a.displayName}</span>
                  </label>
                ))}
              </div>
            </div>
          )}

          {allOptions.transmissions.length > 0 && (
            <div>
              <h3 className="mfd-heading">Transmission</h3>
              <div>
                {allOptions.transmissions.map((t, i) => (
                  <label key={i} className="mfd-radio-label">
                    <input 
                      type="radio" 
                      name="transmission" 
                      value={t} 
                      checked={filters.carTransmission === t} 
                      onChange={(e) => handleFilterChange("carTransmission", e.target.value)} 
                    />
                    <span>{t}</span>
                  </label>
                ))}
              </div>
            </div>
          )}

          {allOptions.steerings.length > 0 && (
            <div>
              <h3 className="mfd-heading">Steering</h3>
              <div>
                {allOptions.steerings.map((s, i) => (
                  <label key={i} className="mfd-radio-label">
                    <input 
                      type="radio" 
                      name="steering" 
                      value={s} 
                      checked={filters.carSteering === s} 
                      onChange={(e) => handleFilterChange("carSteering", e.target.value)} 
                    />
                    <span>{s}</span>
                  </label>
                ))}
              </div>
            </div>
          )}

          {allOptions.prices.length > 0 && (
            <div>
              <h3 className="mfd-heading">Price Range</h3>
              <select 
                className="mfd-select" 
                value={filters.carPrice} 
                onChange={(e) => handleFilterChange("carPrice", e.target.value)}
              >
                <option value="">Select Price Range</option>
                {allOptions.prices.map((p, i) => (
                  <option key={i} value={p}>{p}</option>
                ))}
              </select>
            </div>
          )}
        </div>

        <div className="mfd-footer">
          <div className="mfd-left">
            <div className="mfd-selected-label">Total Filters Selected</div>
            <div className="mfd-selected-count">{getSelectedCount()}</div>
            <button className="mfd-reset-btn" onClick={resetFilters}>
              RESET FILTERS
            </button>
          </div>

          <div>
            <button className="mfd-show-btn" onClick={handleShowCars}>
              SHOW: {filteredTotalItems?.toLocaleString?.() ?? filteredTotalItems ?? 0} CARS
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

// export default MoreFilterDialog;

export default function BasicSelectFilter({ initialFilterState, onApplyFilter }) {

  const memoizedInitialState = useMemo(() => {
    if (!initialFilterState) {
      return {
        selectedCategory: null,
        selectedBrand: null,
        selectedModels: [],
        selectedYears: [],
        colorSelect: '', 
        carDriveType: '', 
        carEngine: '',
        carFilterAccessories: [], 
        carFuelType: '',
        carMileage: '', 
        carPrice: '', 
        carSeat: '',
        carSteering: '', 
        carTransmission: '',
        globalSearch: '',
      };
    }

    const state = {
      selectedCategory: initialFilterState.selectedCategory || null,
      selectedBrand: initialFilterState.selectedBrand || null,
      selectedModels: Array.isArray(initialFilterState.selectedModels) ? initialFilterState.selectedModels : [],
      selectedYears: Array.isArray(initialFilterState.selectedYears) ? initialFilterState.selectedYears : [],
      colorSelect: initialFilterState.colorSelect || '', 
      carDriveType: initialFilterState.carDriveType || '', 
      carEngine: initialFilterState.carEngine || '',
      carFilterAccessories: Array.isArray(initialFilterState.carFilterAccessories) ? initialFilterState.carFilterAccessories : [], 
      carFuelType: initialFilterState.carFuelType || '',
      carMileage: initialFilterState.carMileage || '', 
      carPrice: initialFilterState.carPrice || '', 
      carSeat: initialFilterState.carSeat || '',
      carSteering: initialFilterState.carSteering || '', 
      carTransmission: initialFilterState.carTransmission || '',
      globalSearch: initialFilterState.globalSearch || '',
    };
    
    state.selectedYears = state.selectedYears
      .map(y => ({ year: typeof y === 'object' ? y.year : y }))
      .filter(y => y.year !== null && y.year !== undefined);
      
    state.selectedModels = state.selectedModels
      .map(m => ({ carModelName: typeof m === 'object' ? m.carModelName : m }))
      .filter(m => m.carModelName !== null && m.carModelName !== undefined);
      
    return state;
  }, [initialFilterState]);
  
  const [selectedCategory, setSelectedCategory] = useState(memoizedInitialState.selectedCategory);
  const [selectedBrand, setSelectedBrand] = useState(memoizedInitialState.selectedBrand);
  const [selectedModels, setSelectedModels] = useState(memoizedInitialState.selectedModels);
  const [selectedYears, setSelectedYears] = useState(memoizedInitialState.selectedYears);

  const [isCategoriesLoading, setIsCategoriesLoading] = useState(false);
  const [isBrandsLoading, setIsBrandsLoading] = useState(false);
  const [isModelsLoading, setIsModelsLoading] = useState(false);
  const [isYearsLoading, setIsYearsLoading] = useState(false);

  const [categorySearch, setCategorySearch] = useState(memoizedInitialState.selectedCategory?.label || "");
  const [brandNameSearch, setBrandNameSearch] = useState(memoizedInitialState.selectedBrand?.label || "");
  const [modelNameSearch, setModelNameSearch] = useState(
    memoizedInitialState.selectedModels.map(m => m.carModelName).join(', ')
  );
  const [yearNameSearch, setYearNameSearch] = useState(
    memoizedInitialState.selectedYears.map(y => y.year).join(', ')
  );
  
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [currentFilteredData, setCurrentFilteredData] = useState({ data: [], totalItems: 0, isInitialLoad: true });
  
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isSelectBrandOpen, setIsSelectBrandOpen] = useState(false);
  const [isSelectModelOpen, setIsSelectModelOpen] = useState(false);
  const [isSelectYearOpen, setIsSelectYearOpen] = useState(false);
  
  const [showBrandName, setShowBrandName] = useState(false);
  const [showCategories, setShowCategories] = useState(false);
  const [showModelName, setShowModelName] = useState(false);
  const [showYearName, setShowYearName] = useState(false);
  
  const [bodyTypes, setBodyTypes] = useState([]);
  const [filteredBodyTypes, setFilteredBodyTypes] = useState([]);
  const [brands, setBrands] = useState([]);
  const [allBrands, setAllBrands] = useState([]); // <-- ADD THIS LINE
  const [allModels, setAllModels] = useState([]);
  const [allYears, setAllYears] = useState([]);
  const [popularBrands, setPopularBrands] = useState([]);
  const [remainingBrands, setRemainingBrands] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [groupedBrands, setGroupedBrands] = useState({});
  const [brandsFetched, setBrandsFetched] = useState(false);
  const [models, setModels] = useState([]);
  const [popularModels, setPopularModels] = useState([]);
  const [remainingModels, setRemainingModels] = useState([]);
  const [modelSearchTerm, setModelSearchTerm] = useState("");
  const [groupedModels, setGroupedModels] = useState({});
  const [filteredModels, setFilteredModels] = useState([]);
  const [modelsFetched, setModelsFetched] = useState(false);
  const [years, setYears] = useState([]);
  const [yearSearchTerm, setYearSearchTerm] = useState("");
  const [yearsFetched, setYearsFetched] = useState(false);
  const [groupedYears, setGroupedYears] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  
  const POPULAR_MODELS = [ "PRIUS", "FREED", "AUDI A8", "BEGO", "BMW Z4", "ROOX", "HUSTLER", "BENTLEY" ];
  const POPULAR_BRANDS = [ 
    "TOYOTA", 
    "FORD", 
    "AUDI", 
    "GMC", 
    "BMW", 
    "NISSAN", 
    "SAAB", 
    "VOLVO" 
  ];

  useEffect(() => {
    console.log('Syncing state with props:', memoizedInitialState);
    setSelectedCategory(memoizedInitialState.selectedCategory);
    setSelectedBrand(memoizedInitialState.selectedBrand);
    setSelectedModels(memoizedInitialState.selectedModels);
    setSelectedYears(memoizedInitialState.selectedYears);
    
    setCategorySearch(memoizedInitialState.selectedCategory?.label || "");
    setBrandNameSearch(memoizedInitialState.selectedBrand?.label || "");
    setModelNameSearch(memoizedInitialState.selectedModels.map(m => m.carModelName).join(', '));
    setYearNameSearch(memoizedInitialState.selectedYears.map(y => y.year).join(', '));
  }, [memoizedInitialState]);

  const formatBrandName = (brandName) => { 
    if (!brandName) return ""; 
    return brandName.trim().toUpperCase().replace(/\s+/g, ''); 
  };
  
  const formatModelName = (modelName) => { 
    if (!modelName) return ""; 
    return modelName.trim(); 
  };
  
  const getCategoryIcon = (categoryName) => {
    const iconMap = { 
      SEDAN: "/BrandIcons/body1.svg", 
      SUV: "/BrandIcons/body2.svg", 
      WELFARE: "/BrandIcons/body2.svg", 
      HATCHBACK: "/BrandIcons/body3.svg", 
      VAN: "/BrandIcons/body4.svg", 
      CAB_VAN: "/BrandIcons/body4.svg", 
      CONVERTIBLE: "/BrandIcons/body5.svg", 
      COUPE: "/BrandIcons/body6.svg", 
      WAGON: "/BrandIcons/body6.svg", 
      BUS: "/BrandIcons/body6.svg", 
      TRUCK: "/BrandIcons/body7.svg", 
      DUMP: "/BrandIcons/body7.svg", 
      PICK_UP_TRUCK: "/BrandIcons/body7.svg", 
      MINI_VAN: "/BrandIcons/body4.svg", 
      NO_CATEGORIES_NAME: "/BrandIcons/body6.svg", 
      OPEN: "/BrandIcons/body5.svg" 
    };
    return iconMap[categoryName.toUpperCase()] || "/BrandIcons/default.svg";
  };
  
  const getBrandImage = (brandName) => {
    const imageMap = {
      "ALFAROMEO": "/BrandIcons/Brand_Alfa_Romeo.svg",
      "ALPINA": "/BrandIcons/Brand_Alpina.svg",
      "AMG": "/BrandIcons/Brand_AMG.svg",
      "ASTON MARTIN": "/BrandIcons/Brand_Aston_Martin.svg",
      "ASTONMARTIN": "/BrandIcons/Brand_Aston_Martin.svg",
      "AUDI": "/BrandIcons/Brand_Audi.svg",
      "AUTOBIANCHI": "/BrandIcons/Brand_Autobianchi.svg",
      "BENTLEY": "/BrandIcons/Brand_Bentley.svg",
      "BMW": "/BrandIcons/Brand_BMW.svg",
      "BRABUS": "/BrandIcons/Brand_Brabus.svg",
      "BYD": "/BrandIcons/Brand_BYD.svg",
      "CADILLAC": "/BrandIcons/Brand_Cadillac.svg",
      "CHEVROLET": "/BrandIcons/Brand_Chevrolet.svg",
      "CHRYSLER": "/BrandIcons/Brand_Chrysler.svg",
      "CITROEN": "/BrandIcons/Brand_Citroen.svg",
      "DAIHATSU": "/BrandIcons/Brand_Daihatsu.svg",
      "DAIMLER": "/BrandIcons/Brand_Daimler.svg",
      "DODGE": "/BrandIcons/Brand_Dodge.svg",
      "ENGLAND Others": "/BrandIcons/Brand_Daimler.svg",
      "ENGLANDOTHERS": "/BrandIcons/Brand_Daimler.svg",
      "FERRARI": "/BrandIcons/Brand_Ferrari.svg",
      "FIAT": "/BrandIcons/Brand_Fiat.svg",
      "FORD": "/BrandIcons/Brand_Ford.svg",
      "GMC": "/BrandIcons/Brand_GMC.svg",
      "HINO": "/BrandIcons/Brand_Hino.svg",
      "HONDA": "/BrandIcons/Brand_Honda.svg",
      "HUMMER": "/BrandIcons/Brand_Hummer.svg",
      "HYUNDAI": "/BrandIcons/Brand_Hyundai.svg",
      "INFINITY": "/BrandIcons/Brand_Infiniti.svg",
      "ISUZU": "/BrandIcons/Brand_Isuzu.svg",
      "JAGUAR": "/BrandIcons/Brand_Jaguar.svg",
      "JEEP": "/BrandIcons/Brand_Jeep.svg",
      "LAMBORGHINI": "/BrandIcons/Brand_Lamborghini.svg",
      "LANCIA": "/BrandIcons/Brand_Lancia-50.svg",
      "LAND ROVER": "/BrandIcons/Brand_Land Rover.svg",
      "LANDROVER": "/BrandIcons/Brand_Land Rover.svg",
      "LEXUS": "/BrandIcons/Brand_Lexus.svg",
      "LINCOLN": "/BrandIcons/Brand_Lincoln.svg",
      "LOTUS": "/BrandIcons/Brand_Lotus.svg",
      "MASERATI": "/BrandIcons/Brand_Maserati.svg",
      "MAZDA": "/BrandIcons/Brand_MAZDA.svg",
      "MCC": "/BrandIcons/Brand_Daimler.svg",
      "MERCEDES BENZ": "/BrandIcons/Brand_Mercedes.svg",
      "MERCEDESBENZ": "/BrandIcons/Brand_Mercedes.svg",
      "MINI": "/BrandIcons/Brand_Mini.svg",
      "MITSUBISHI": "/BrandIcons/Brand_Fuso.svg",
      "MITSUBISHI FUSOU": "/BrandIcons/Brand_Fuso.svg",
      "MITSUBISHIFUSOU": "/BrandIcons/Brand_Fuso.svg",
      "MITSUOKA": "/BrandIcons/Brand_Matsuoka.svg",
      "MOKE": "/BrandIcons/Brand_MOKE.svg",
      "NISSAN": "/BrandIcons/Brand_Nissan.svg",
      "NISSAN DIESEL": "/BrandIcons/Brand_Nissan.svg",
      "NISSANDIESEL": "/BrandIcons/Brand_Nissan.svg",
      "OPEL": "/BrandIcons/Brand_Opel.svg",
      "Others": "/BrandIcons/Brand_Others.svg",
      "PEUGEOT": "/BrandIcons/Brand_Peugeot.svg",
      "PORSCHE": "/BrandIcons/Brand_Porsche.svg",
      "RENAULT": "/BrandIcons/Brand_Renault.svg",
      "ROLLS-ROYCE": "/BrandIcons/Brand_Rolls Royce.svg",
      "ROVER": "/BrandIcons/Brand_Land Rover.svg",
      "SAAB": "/BrandIcons/Brand_Saab.svg",
      "SEAT": "/BrandIcons/Brand_Seat.svg",
      "SMART": "/BrandIcons/Brand_Smart.svg",
      "SUBARU": "/BrandIcons/Brand_Saabaru.svg",
      "SUZUKI": "/BrandIcons/Brand_Suzuki.svg",
      "TOYOTA": "/BrandIcons/Brand_Toyota.svg",
      "VOLKSWAGEN": "/BrandIcons/Brand_Volkswagen.svg",
      "VOLVO": "/BrandIcons/Brand_Volvo.svg",
      "MYBACH": "/BrandIcons/Brand_Mercedes.svg",
      "TESLA": "/BrandIcons/Brand_Tesla.svg",
      "PONTIAC": "/BrandIcons/Brand_PONTIAC.svg",
    };
    
    return imageMap[brandName] || imageMap[formatBrandName(brandName)] || "/BrandIcons/default.svg";
  };

  const getModelImage = (modelName) => {
    const imageMap = {
      "PRIUS": "/BrandIcons/Brand_Toyota.svg",
      "FREED": "/BrandIcons/Brand_Honda.svg",
      "AUDI A8": "/BrandIcons/Brand_Audi.svg",
      "BEGO": "/BrandIcons/Brand_Daihatsu.svg",
      "BMW Z4": "/BrandIcons/Brand_BMW.svg",
      "ROOX": "/BrandIcons/Brand_Nissan.svg",
      "HUSTLER": "/BrandIcons/Brand_Suzuki.svg",
      "BENTLEY": "/BrandIcons/Brand_Bentley.svg",
    };
    return imageMap[modelName];
  };
  
  // const chunkArray = (array, size) => { 
  //   let columnSize = size;
    
  //   if (typeof window !== 'undefined') {
  //     const width = window.innerWidth;
  //     if (width >= 2400) {
  //       columnSize = 5;
  //     } else if (width >= 1920) {
  //       columnSize = 4;
  //     } else if (width >= 1200) {
  //       columnSize = 4;
  //     } else if (width >= 1024) {
  //       columnSize = 2;
  //     } else if (width >= 768) {
  //       columnSize = 3;
  //     } else if (width >= 425) {
  //       columnSize = 3;
  //     } else {
  //       columnSize = 2;
  //     }
  //   }
    
  //   const result = []; 
  //   for (let i = 0; i < array.length; i += columnSize) { 
  //     result.push(array.slice(i, i + columnSize)); 
  //   } 
  //   return result; 
  // };
  const chunkArray = (array, size = 2) => {
  let columnSize = size;

  if (typeof window !== "undefined") {
    const width = window.innerWidth;

    if (width >= 2560) {
      columnSize = 5;
    } else if (width >= 1440) {
      columnSize = 4;
    } else if (width >= 1020) {
      columnSize = 4;
    } else if (width >= 768) {
      columnSize = 4;
    } else if (width >= 425) {
      columnSize = 4;
    } else if (width >= 375) {
      columnSize = 4;
    } else if (width >= 320) {
      columnSize = 4;
    } else {
      columnSize = 2;
    }
  }

  const result = [];
  for (let i = 0; i < array.length; i += columnSize) {
    result.push(array.slice(i, i + columnSize));
  }

  return result;
};


  const notifyParentOfChange = useCallback((updates) => {
    if (onApplyFilter) {
      const updatedState = {
        selectedCategory,
        selectedBrand,
        selectedModels,
        selectedYears,
        ...memoizedInitialState,
        ...updates
      };
      console.log('Notifying parent with state:', updatedState);
      onApplyFilter(updatedState);
    }
  }, [onApplyFilter, selectedCategory, selectedBrand, selectedModels, selectedYears, memoizedInitialState]);

  const resetDependentFilters = useCallback(() => {
    setSelectedBrand(null);
    setBrandNameSearch("");
    setSearchTerm("");
    setSelectedModels([]);
    setModelNameSearch("");
    setModelSearchTerm("");
    setSelectedYears([]);
    setYearNameSearch("");
    setYearSearchTerm("");
    setIsSelectBrandOpen(false);
    setIsSelectModelOpen(false);
    setIsSelectYearOpen(false);
    setBrands([]); 
    setPopularBrands([]); 
    setRemainingBrands([]); 
    setGroupedBrands({});
    setModels([]); 
    setPopularModels([]); 
    setRemainingModels([]); 
    setGroupedModels({});
    setModelsFetched(false);
  }, []);

  const handleBodyTypeReset = async () => {
    setCategorySearch("");
    setSelectedCategory(null);
    setShowCategories(false);
    resetDependentFilters();
    await fetchAllCategories();
    
    notifyParentOfChange({
      selectedCategory: null,
      selectedBrand: null,
      selectedModels: [],
      selectedYears: []
    });
  };
  
  // const handleBrandReset = async () => {
  //   setSelectedBrand(null);
  //   setBrandNameSearch("");
  //   setSearchTerm("");
  //   setSelectedModels([]);
  //   setModelNameSearch("");
  //   setModelSearchTerm("");
  //   setSelectedYears([]);
  //   setYearNameSearch("");
  //   setYearSearchTerm("");
  //   await fetchAllBrands();
  //   setIsSelectBrandOpen(false);
    
  //   notifyParentOfChange({
  //     selectedBrand: null,
  //     selectedModels: [],
  //     selectedYears: []
  //   });
  // };

  const handleBrandReset = async () => {
  setSelectedBrand(null);
  setBrandNameSearch("");
  setSearchTerm("");
  setSelectedModels([]);
  setModelNameSearch("");
  setModelSearchTerm("");
  setSelectedYears([]);
  setYearNameSearch("");
  setYearSearchTerm("");
  
  // Reset to show all brands again
  if (allBrands.length > 0) {
    processBrandList(allBrands, false);
  } else {
    await fetchAllBrands();
  }
  
  setIsSelectBrandOpen(false);
  
  notifyParentOfChange({
    selectedBrand: null,
    selectedModels: [],
    selectedYears: []
  });
};

  const handleModelReset = () => {
    setSelectedModels([]);
    setModelNameSearch("");
    setModelSearchTerm("");
    setAllModels([]);  
    setSelectedYears([]);
    setYearNameSearch("");
    setYearSearchTerm("");
    fetchAllModels();
    
    notifyParentOfChange({
      selectedModels: [],
      selectedYears: []
    });
  };
  
  const handleYearReset = () => {
    setSelectedYears([]);
    setYearNameSearch("");
    setYearSearchTerm("");
    setAllYears([]);  
    fetchAllYears();
    
    notifyParentOfChange({
      selectedYears: []
    });
  };

  const handleOpenFilterModal = () => { setFilterModalOpen(true); };
  const handleCloseFilterModal = () => { setFilterModalOpen(false); };
  
  const handleTextFieldFocus = (event) => {
    event.stopPropagation();
    setShowCategories(true);
    setFilteredBodyTypes(bodyTypes);
  };

  const handleBrandTextFieldFocus = (event) => { 
    event.stopPropagation(); 
    setShowBrandName(true); 
  };
  
  const handleModelTextFieldFocus = (event) => { 
    event.stopPropagation(); 
    setShowModelName(true); 
  };

  const handleSelectOpen = () => { setIsDropdownOpen(true); };
  
  const handleSelectClose = (event) => {
    if (event.target.closest(".filter-body-type-main")) { 
      event.stopPropagation(); 
      return; 
    }
    setIsDropdownOpen(false);
  };
  
  // const fetchAllCategories = async () => {
  //   try {
  //     const response = await fetch("https://car.amar.co.jp/api/master/car-catgories/get-all-categories", { 
  //       headers: { Accept: "application/json", "Accept-Language": "en" } 
  //     });
  //     const result = await response.json();
  //     if (result.status === 200 && result.data) {
  //       const mappedBodyTypes = result.data.map((category) => ({
  //         label: category.categoriesName.trim() === "NO_CATEGORIES_NAME" ? "CONVERTIBLE" : category.categoriesName.trim(),
  //         src: getCategoryIcon(category.categoriesName.trim()),
  //       }));
  //       setBodyTypes(mappedBodyTypes);
  //       setFilteredBodyTypes(mappedBodyTypes);
  //     }
  //   } catch (error) { 
  //     console.error("Error fetching categories:", error); 
  //   }
  // };
//   const fetchAllCategories = async () => {
//   try {
//     const response = await fetch("https://car.amar.co.jp/api/master/car-catgories/get-all-categories", { 
//       headers: { Accept: "application/json", "Accept-Language": "en" } 
//     });
//     const result = await response.json();
//     if (result.status === 200 && result.data) {
//       // Pehle saari categories ko map karo
//       const mapped = result.data.map((category) => ({
//         label: category.categoriesName.trim() === "NO_CATEGORIES_NAME" ? "CONVERTIBLE" : category.categoriesName.trim(),
//         src: getCategoryIcon(category.categoriesName.trim()),
//       }));

//       // AB YAHA DUPLICATES HATAO (Unique filter)
//       const uniqueBodyTypes = mapped.filter((item, index, self) =>
//         index === self.findIndex((t) => t.label === item.label)
//       );

//       setBodyTypes(uniqueBodyTypes);
//       setFilteredBodyTypes(uniqueBodyTypes);
//     }
//   } catch (error) { 
//     console.error("Error fetching categories:", error); 
//   }
// };
const fetchAllCategories = async () => {
  setIsCategoriesLoading(true);  // ADD THIS
  try {
    const response = await fetch("https://car.amar.co.jp/api/master/car-catgories/get-all-categories", { 
      headers: { Accept: "application/json", "Accept-Language": "en" } 
    });
    const result = await response.json();
    if (result.status === 200 && result.data) {
      const mapped = result.data.map((category) => ({
        label: category.categoriesName.trim() === "NO_CATEGORIES_NAME" ? "CONVERTIBLE" : category.categoriesName.trim(),
        src: getCategoryIcon(category.categoriesName.trim()),
      }));

      const uniqueBodyTypes = mapped.filter((item, index, self) =>
        index === self.findIndex((t) => t.label === item.label)
      );

      setBodyTypes(uniqueBodyTypes);
      setFilteredBodyTypes(uniqueBodyTypes);
    }
  } catch (error) { 
    console.error("Error fetching categories:", error); 
  } finally {
    setIsCategoriesLoading(false);  // ADD THIS
  }
};

  const fetchFilteredCategories = async (searchTerm) => {
    setCategorySearch(searchTerm);
    setShowCategories(true);
    if (!searchTerm) {
      setFilteredBodyTypes(bodyTypes);
      return;
    }
    const filtered = bodyTypes.filter((type) => 
      type.label.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredBodyTypes(filtered);
  };
  
  // const selectCategory = (category, event) => {
  //   event.stopPropagation();
  //   setSelectedCategory(category);
  //   setCategorySearch(category.label);
    
  //   setSelectedBrand(null);
  //   setBrandNameSearch("");
  //   setSelectedModels([]);
  //   setModelNameSearch("");
  //   setSelectedYears([]);
  //   setYearNameSearch("");
    
  //   setShowCategories(false);
  //   setIsDropdownOpen(false);
    
  //   setModels([]);
  //   setPopularModels([]);
  //   setRemainingModels([]);
  //   setGroupedModels({});
  //   setModelsFetched(false);
    
  //   fetchAllBrands();
    
  //   notifyParentOfChange({
  //     selectedCategory: category,
  //     selectedBrand: null,
  //     selectedModels: [],
  //     selectedYears: []
  //   });
  // };
  // const selectCategory = (category, event) => {
  //   event.stopPropagation();
  //   setSelectedCategory(category);
  //   setCategorySearch(category.label);
    
  //   setSelectedBrand(null);
  //   setBrandNameSearch("");
  //   setSelectedModels([]);
  //   setModelNameSearch("");
  //   setSelectedYears([]);
  //   setYearNameSearch("");
    
  //   setShowCategories(false);
  //   setIsDropdownOpen(false);
    
  //   // Reset brands data
  //   setBrandsFetched(false);
  //   setBrands([]);
  //   setPopularBrands([]);
  //   setRemainingBrands([]);
  //   setGroupedBrands({});
    
  //   // Reset models data
  //   setModels([]);
  //   setPopularModels([]);
  //   setRemainingModels([]);
  //   setGroupedModels({});
  //   setModelsFetched(false);
    
  //   // Reset years data
  //   setYearsFetched(false);
    
  //   fetchAllBrands(category);
    
  //   notifyParentOfChange({
  //     selectedCategory: category,
  //     selectedBrand: null,
  //     selectedModels: [],
  //     selectedYears: []
  //   });
  // };
//   const selectCategory = (category, event) => {
//   event.stopPropagation();
//   setSelectedCategory(category);
//   setCategorySearch(category.label);
  
//   setSelectedBrand(null);
//   setBrandNameSearch("");
//   setSelectedModels([]);
//   setModelNameSearch("");
//   setSelectedYears([]);
//   setYearNameSearch("");
  
//   setShowCategories(false);
//   setIsDropdownOpen(false);
  
//   // Reset brands data
//   setBrandsFetched(false);
//   setBrands([]);
//   setPopularBrands([]);
//   setRemainingBrands([]);
//   setGroupedBrands({});
  
//   // Reset models data
//   setModels([]);
//   setPopularModels([]);
//   setRemainingModels([]);
//   setGroupedModels({});
//   setModelsFetched(false);
  
//   // ========== ADD THIS: Reset years data ==========
//   setYears([]);
//   setGroupedYears({});
//   setYearsFetched(false);
//   // ================================================
  
//   fetchAllBrands(category);
  
//   notifyParentOfChange({
//     selectedCategory: category,
//     selectedBrand: null,
//     selectedModels: [],
//     selectedYears: []
//   });
// };
const selectCategory = (category, event) => {
  event.stopPropagation();
  setSelectedCategory(category);
  setCategorySearch(category.label);
  
  setSelectedBrand(null);
  setBrandNameSearch("");
  setSelectedModels([]);
  setModelNameSearch("");
  setSelectedYears([]);
  setYearNameSearch("");
  
  setShowCategories(false);
  setIsDropdownOpen(false);
  
  // Reset all dependent data
  setBrandsFetched(false);
  setBrands([]);
  setAllBrands([]); 
  setPopularBrands([]);
  setRemainingBrands([]);
  setGroupedBrands({});
  
  setModels([]);
  setAllModels([]);
  setPopularModels([]);
  setRemainingModels([]);
  setGroupedModels({});
  setModelsFetched(false);
  
  setYears([]);
  setAllYears([]); 
  setGroupedYears({});
  setYearsFetched(false);
  
  // ✅ IMMEDIATE FETCH - No waiting for state updates
  fetchAllBrands(category);
  fetchAllModels(category, null);
  fetchAllYears(category, null, []);
  
  notifyParentOfChange({
    selectedCategory: category,
    selectedBrand: null,
    selectedModels: [],
    selectedYears: []
  });
};

  
  // const fetchAllBrands = useCallback(async () => {
  //   try {
  //     if (selectedCategory) {

  // const fetchAllBrands = useCallback(async (categoryToUse = null) => {
  // try {
  //   const category = categoryToUse || selectedCategory;
  //   if (category) {
  //       console.log("Fetching brands for category:", selectedCategory.label);
  //       const queryParams = { 
  //         categoryName: selectedCategory.label, 
  //         page: 0, 
  //         size: 100 
  //       };
  //       const response = await axios.get('https://car.amar.co.jp/api/dashboard/filter/advance-filter-new', { 
  //         params: queryParams, 
  //         headers: { Accept: "application/json", "Accept-Language": "en" } 
  //       });
  //       const data = response.data;
  //       if (data.data && Array.isArray(data.data)) {
  //         const uniqueBrands = Array.from(
  //           new Set(data.data.map(item => item.carBrandName).filter(Boolean))
  //         ).map(brandName => ({ 
  //           carBrandName: formatBrandName(brandName) 
  //         }));
  //         console.log("Filtered brands:", uniqueBrands);
  //         processBrandList(uniqueBrands);
  //       } else {
  //         processBrandList([]);
  //       }
  //     } else {
  //       const response = await axios.get("https://car.amar.co.jp/api/master/car-brand/get-all-brandName", { 
  //         headers: { accept: "application/json", "Accept-Language": "en" } 
  //       });
  //       if (response.data.carBrandList) { 
  //         processBrandList(response.data.carBrandList); 
  //       } else {
  //         processBrandList([]);
  //       }
  //     }
  //     setBrandsFetched(true);
  //   } catch (error) { 
  //     console.error("Error fetching brands:", error); 
  //     setBrandsFetched(true); 
  //   }
  // }, [selectedCategory]); 
//   const fetchAllBrands = useCallback(async (categoryToUse = null) => {
//   try {
//     const category = categoryToUse || selectedCategory;
    
//     if (category) {
//       console.log("Fetching brands for category:", category.label);
//       const queryParams = { 
//         categoryName: category.label,  // ✅ FIX: category.label use karo, selectedCategory.label NAHI
//         page: 0, 
//         size: 100 
//       };
//       const response = await axios.get('https://car.amar.co.jp/api/dashboard/filter/advance-filter-new', { 
//         params: queryParams, 
//         headers: { Accept: "application/json", "Accept-Language": "en" } 
//       });
//       const data = response.data;
//       if (data.data && Array.isArray(data.data)) {
//         const uniqueBrands = Array.from(
//           new Set(data.data.map(item => item.carBrandName).filter(Boolean))
//         ).map(brandName => ({ 
//           carBrandName: formatBrandName(brandName) 
//         }));
//         console.log("Filtered brands:", uniqueBrands);
//         processBrandList(uniqueBrands);
//       } else {
//         processBrandList([]);
//       }
//     } else {
//       // No category selected - fetch all brands
//       const response = await axios.get("https://car.amar.co.jp/api/master/car-brand/get-all-brandName", { 
//         headers: { accept: "application/json", "Accept-Language": "en" } 
//       });
//       if (response.data.carBrandList) { 
//         processBrandList(response.data.carBrandList); 
//       } else {
//         processBrandList([]);
//       }
//     }
//     setBrandsFetched(true);
//   } catch (error) { 
//     console.error("Error fetching brands:", error); 
//     setBrandsFetched(true); 
//   }
// }, [selectedCategory]);  // dependency array same rahega
// const fetchAllBrands = useCallback(async (categoryToUse = null) => {
//   setIsBrandsLoading(true);  // ADD THIS
//   try {
//     const category = categoryToUse || selectedCategory;
    
//     if (category) {
//       console.log("Fetching brands for category:", category.label);
//       const queryParams = { 
//         categoryName: category.label,
//         page: 0, 
//         size: 100 
//       };
//       const response = await axios.get('https://car.amar.co.jp/api/dashboard/filter/advance-filter-new', { 
//         params: queryParams, 
//         headers: { Accept: "application/json", "Accept-Language": "en" } 
//       });
//       const data = response.data;
//       if (data.data && Array.isArray(data.data)) {
//         const uniqueBrands = Array.from(
//           new Set(data.data.map(item => item.carBrandName).filter(Boolean))
//         ).map(brandName => ({ 
//           carBrandName: formatBrandName(brandName) 
//         }));
//         console.log("Filtered brands:", uniqueBrands);
//         processBrandList(uniqueBrands);
//       } else {
//         processBrandList([]);
//       }
//     } else {
//       const response = await axios.get("https://car.amar.co.jp/api/master/car-brand/get-all-brandName", { 
//         headers: { accept: "application/json", "Accept-Language": "en" } 
//       });
//       if (response.data.carBrandList) { 
//         processBrandList(response.data.carBrandList); 
//       } else {
//         processBrandList([]);
//       }
//     }
//     setBrandsFetched(true);
//   } catch (error) { 
//     console.error("Error fetching brands:", error); 
//     setBrandsFetched(true); 
//   } finally {
//     setIsBrandsLoading(false);  // ADD THIS
//   }
// }, [selectedCategory]);
const fetchAllBrands = useCallback(async (categoryToUse = null) => {
  setIsBrandsLoading(true);
  try {
    const category = categoryToUse || selectedCategory;
    
    if (category) {
      console.log("Fetching brands for category:", category.label);
      const queryParams = { 
        categoryName: category.label,
        page: 0, 
        size: 100 
      };
      const response = await axios.get('https://car.amar.co.jp/api/dashboard/filter/advance-filter-new', { 
        params: queryParams, 
        headers: { Accept: "application/json", "Accept-Language": "en" } 
      });
      const data = response.data;
      if (data.data && Array.isArray(data.data)) {
        const uniqueBrands = Array.from(
          new Set(data.data.map(item => item.carBrandName).filter(Boolean))
        ).map(brandName => ({ 
          carBrandName: formatBrandName(brandName) 
        }));
        console.log("Filtered brands:", uniqueBrands);
        processBrandList(uniqueBrands, true); // <-- ADD true HERE
      } else {
        processBrandList([], true); // <-- ADD true HERE
      }
    } else {
      const response = await axios.get("https://car.amar.co.jp/api/master/car-brand/get-all-brandName", { 
        headers: { accept: "application/json", "Accept-Language": "en" } 
      });
      if (response.data.carBrandList) { 
        processBrandList(response.data.carBrandList, true); // <-- ADD true HERE
      } else {
        processBrandList([], true); // <-- ADD true HERE
      }
    }
    setBrandsFetched(true);
  } catch (error) { 
    console.error("Error fetching brands:", error); 
    setBrandsFetched(true); 
  } finally {
    setIsBrandsLoading(false);
  }
}, [selectedCategory]);

  
  // const processBrandList = (brandList) => {
  //   if (!Array.isArray(brandList)) {
  //     setPopularBrands([]);
  //     setRemainingBrands([]);
  //     setGroupedBrands({});
  //     setBrands([]);
  //     return;
  //   }
    
  //   const uniqueBrands = Array.from(
  //     new Set(brandList.map(brand => brand.carBrandName).filter(Boolean))
  //   ).map(brandName => ({ carBrandName: brandName }));
    
  //   const popular = uniqueBrands.filter((brand) => 
  //     POPULAR_BRANDS.includes(formatBrandName(brand.carBrandName))
  //   );
    
  //   popular.sort((a, b) => 
  //     POPULAR_BRANDS.indexOf(formatBrandName(a.carBrandName)) - 
  //     POPULAR_BRANDS.indexOf(formatBrandName(b.carBrandName))
  //   );
    
  //   const remaining = uniqueBrands.filter((brand) => 
  //     !POPULAR_BRANDS.includes(formatBrandName(brand.carBrandName))
  //   );
    
  //   const grouped = remaining.reduce((acc, brand) => { 
  //     const firstLetter = brand.carBrandName.charAt(0).toUpperCase(); 
  //     if (!acc[firstLetter]) { 
  //       acc[firstLetter] = []; 
  //     } 
  //     acc[firstLetter].push(brand); 
  //     return acc; 
  //   }, {});
    
  //   Object.keys(grouped).forEach(letter => { 
  //     grouped[letter].sort((a, b) => a.carBrandName.localeCompare(b.carBrandName)); 
  //   });
    
  //   setPopularBrands(popular);
  //   setRemainingBrands(remaining);
  //   setGroupedBrands(grouped);
  //   setBrands(uniqueBrands);
  // };
  
//   const processBrandList = (brandList, isInitialLoad = false) => {
//   if (!Array.isArray(brandList)) {
//     setPopularBrands([]);
//     setRemainingBrands([]);
//     setGroupedBrands({});
//     setBrands([]);
//     if (isInitialLoad) {
//       setAllBrands([]);
//     }
//     return;
//   }
  
//   const uniqueBrands = Array.from(
//     new Set(brandList.map(brand => brand.carBrandName).filter(Boolean))
//   ).map(brandName => ({ carBrandName: brandName }));
  
//   const popular = uniqueBrands.filter((brand) => 
//     POPULAR_BRANDS.includes(formatBrandName(brand.carBrandName))
//   );
  
//   popular.sort((a, b) => 
//     POPULAR_BRANDS.indexOf(formatBrandName(a.carBrandName)) - 
//     POPULAR_BRANDS.indexOf(formatBrandName(b.carBrandName))
//   );
  
//   const remaining = uniqueBrands.filter((brand) => 
//     !POPULAR_BRANDS.includes(formatBrandName(brand.carBrandName))
//   );
  
//   const grouped = remaining.reduce((acc, brand) => { 
//     const firstLetter = brand.carBrandName.charAt(0).toUpperCase(); 
//     if (!acc[firstLetter]) { 
//       acc[firstLetter] = []; 
//     } 
//     acc[firstLetter].push(brand); 
//     return acc; 
//   }, {});
  
//   Object.keys(grouped).forEach(letter => { 
//     grouped[letter].sort((a, b) => a.carBrandName.localeCompare(b.carBrandName)); 
//   });
  
//   setPopularBrands(popular);
//   setRemainingBrands(remaining);
//   setGroupedBrands(grouped);
//   setBrands(uniqueBrands);
  
//   // Only update allBrands on initial load (not during search filtering)
//   if (isInitialLoad) {
//     setAllBrands(uniqueBrands);
//   }
// };

const processBrandList = (brandList, isInitialLoad = false) => {
  if (!Array.isArray(brandList)) {
    setPopularBrands([]);
    setRemainingBrands([]);
    setGroupedBrands({});
    setBrands([]);
    if (isInitialLoad) {
      setAllBrands([]);
    }
    return;
  }
  
  const uniqueBrands = Array.from(
    new Set(brandList.map(brand => brand.carBrandName).filter(Boolean))
  ).map(brandName => ({ carBrandName: brandName }));
  
  // Popular brands - now filtered from the passed brandList (which may be search-filtered)
  const popular = uniqueBrands.filter((brand) => 
    POPULAR_BRANDS.includes(formatBrandName(brand.carBrandName))
  );
  
  // Sort popular brands according to POPULAR_BRANDS order
  popular.sort((a, b) => 
    POPULAR_BRANDS.indexOf(formatBrandName(a.carBrandName)) - 
    POPULAR_BRANDS.indexOf(formatBrandName(b.carBrandName))
  );
  
  // Remaining brands (non-popular) for grouped section
  const remaining = uniqueBrands.filter((brand) => 
    !POPULAR_BRANDS.includes(formatBrandName(brand.carBrandName))
  );
  
  const grouped = remaining.reduce((acc, brand) => { 
    const firstLetter = brand.carBrandName.charAt(0).toUpperCase(); 
    if (!acc[firstLetter]) { 
      acc[firstLetter] = []; 
    } 
    acc[firstLetter].push(brand); 
    return acc; 
  }, {});
  
  Object.keys(grouped).forEach(letter => { 
    grouped[letter].sort((a, b) => a.carBrandName.localeCompare(b.carBrandName)); 
  });
  
  setPopularBrands(popular);
  setRemainingBrands(remaining);
  setGroupedBrands(grouped);
  setBrands(uniqueBrands);
  
  // Only update allBrands on initial load (not during search filtering)
  if (isInitialLoad) {
    setAllBrands(uniqueBrands);
  }
};

  // const fetchFilteredBrandName = async (searchTerm) => {
  //   setSearchTerm(searchTerm);
  //   if (!searchTerm) {
  //     processBrandList(brands);
  //     return;
  //   }
  //   const filtered = brands.filter(brand =>
  //     brand.carBrandName.toLowerCase().includes(searchTerm.toLowerCase())
  //   );
  //   processBrandList(filtered);
  // };
  const fetchFilteredBrandName = async (searchTerm) => {
  setSearchTerm(searchTerm);
  setBrandNameSearch(searchTerm); // Update the input field value
  
  if (!searchTerm || searchTerm.trim() === "") {
    // When search is empty, restore ALL original brands
    processBrandList(allBrands, false); // false = don't overwrite allBrands
    return;
  }
  
  // Filter from the ORIGINAL allBrands list, not the current filtered brands
  const filtered = allBrands.filter(brand =>
    brand.carBrandName.toLowerCase().includes(searchTerm.toLowerCase())
  );
  processBrandList(filtered, false); // false = don't overwrite allBrands
};

  // const handleBrandSelection = async (selectedBrandName) => {
  //   const newBrand = { label: selectedBrandName };
  //   setSelectedBrand(newBrand);
  //   setBrandNameSearch(selectedBrandName);
  //   setIsSelectBrandOpen(false);

  //   setSelectedModels([]);
  //   setModelNameSearch("");
  //   setModelSearchTerm("");
  //   setSelectedYears([]);
  //   setYearNameSearch("");
    
  //   setModels([]);
  //   setPopularModels([]);
  //   setRemainingModels([]);
  //   setGroupedModels({});
  //   setModelsFetched(false);
    
  //   fetchAllModels(selectedCategory, newBrand);
    
  //   notifyParentOfChange({
  //     selectedBrand: newBrand,
  //     selectedModels: [],
  //     selectedYears: []
  //   });
  // };

  // const fetchAllModels = useCallback(async () => {
  //   try {
  //     const categoryName = selectedCategory?.label || "";
  //     const brandName = selectedBrand?.label || "";

  //     console.log("Fetching models with filters:", {
  //       category: categoryName,
  //       brand: brandName
  //     });
      
  //     const params = { 
  //       categoryName: categoryName, 
  //       brandName: brandName, 
  //       page: '0', 
  //       size: '100' 
  //     };
      
  //     console.log("API params for models:", params);
      
  //     const response = await axios.get('https://car.amar.co.jp/api/dashboard/filter/advance-filter-new', { 
  //       params: params, 
  //       headers: { Accept: "application/json", "Accept-Language": "en" } 
  //     });
      
  //     const data = response.data;
  //     if (data.data && Array.isArray(data.data)) {
  //       const uniqueModels = Array.from(
  //         new Set(data.data.map(item => item.carModelName).filter(Boolean))
  //       ).map(modelName => ({ 
  //         carModelName: formatModelName(modelName) 
  //       }));
  //       console.log("Fetched models:", uniqueModels.length, uniqueModels);
  //       processModelList(uniqueModels);
  //     } else { 
  //       console.log("No models data found");
  //       processModelList([]);
  //     }
  //     setModelsFetched(true);
  //   } catch (error) { 
  //     console.error("Error fetching models:", error); 
  //     processModelList([]);
  //     setModelsFetched(true); 
  //   }
  // }, [selectedCategory, selectedBrand]);

//   const handleBrandSelection = async (selectedBrandName) => {
//   const newBrand = { label: selectedBrandName };
  
//   // IMPORTANT: First clear models data BEFORE setting new brand
//   setModels([]);
//   setPopularModels([]);
//   setRemainingModels([]);
//   setGroupedModels({});
//   setModelsFetched(false);
  
//   // Now set new brand
//   setSelectedBrand(newBrand);
//   setBrandNameSearch(selectedBrandName);
//   setIsSelectBrandOpen(false);

//   // Clear dependent selections
//   setSelectedModels([]);
//   setModelNameSearch("");
//   setModelSearchTerm("");
//   setSelectedYears([]);
//   setYearNameSearch("");
  
//   // Fetch models with explicit parameters (not relying on state)
//   await fetchAllModels(selectedCategory, newBrand);
  
//   notifyParentOfChange({
//     selectedBrand: newBrand,
//     selectedModels: [],
//     selectedYears: []
//   });
// };
// const handleBrandSelection = async (selectedBrandName) => {
//   const newBrand = { label: selectedBrandName };
  
//   // IMPORTANT: First clear models data BEFORE setting new brand
//   setModels([]);
//   setPopularModels([]);
//   setRemainingModels([]);
//   setGroupedModels({});
//   setModelsFetched(false);
  
//   // ========== ADD THIS: Clear years data ==========
//   setYears([]);
//   setGroupedYears({});
//   setYearsFetched(false);
//   setSelectedYears([]);
//   setYearNameSearch("");
//   // ================================================
  
//   // Now set new brand
//   setSelectedBrand(newBrand);
//   setBrandNameSearch(selectedBrandName);
//   setIsSelectBrandOpen(false);

//   // Clear dependent selections
//   setSelectedModels([]);
//   setModelNameSearch("");
//   setModelSearchTerm("");
  
//   // Fetch models with explicit parameters (not relying on state)
//   await fetchAllModels(selectedCategory, newBrand);
  
//   notifyParentOfChange({
//     selectedBrand: newBrand,
//     selectedModels: [],
//     selectedYears: []
//   });
// };
const handleBrandSelection = async (selectedBrandName) => {
  const newBrand = { label: selectedBrandName };
  
  // Clear dependent data
  setModels([]);
  setAllModels([]);
  setPopularModels([]);
  setRemainingModels([]);
  setGroupedModels({});
  setModelsFetched(false);
  
  setYears([]);
  setAllYears([]);
  setGroupedYears({});
  setYearsFetched(false);
  setSelectedYears([]);
  setYearNameSearch("");
  
  setSelectedBrand(newBrand);
  setBrandNameSearch(selectedBrandName);
  setIsSelectBrandOpen(false);

  setSelectedModels([]);
  setModelNameSearch("");
  setModelSearchTerm("");
  
  // ✅ IMMEDIATE FETCH with explicit params
  await fetchAllModels(selectedCategory, newBrand);
  await fetchAllYears(selectedCategory, newBrand, []);
  
  notifyParentOfChange({
    selectedBrand: newBrand,
    selectedModels: [],
    selectedYears: []
  });
};

//   const fetchAllModels = useCallback(async (categoryToUse = null, brandToUse = null) => {
//   try {
//     // Use passed parameters first, fallback to state
//     const category = categoryToUse || selectedCategory;
//     const brand = brandToUse || selectedBrand;
    
//     const categoryName = category?.label || "";
//     const brandName = brand?.label || "";

//     console.log("Fetching models with filters:", {
//       category: categoryName,
//       brand: brandName
//     });
    
//     const params = { 
//       categoryName: categoryName, 
//       brandName: brandName, 
//       page: '0', 
//       size: '100' 
//     };
    
//     console.log("API params for models:", params);
    
//     const response = await axios.get('https://car.amar.co.jp/api/dashboard/filter/advance-filter-new', { 
//       params: params, 
//       headers: { Accept: "application/json", "Accept-Language": "en" } 
//     });
    
//     const data = response.data;
//     if (data.data && Array.isArray(data.data)) {
//       const uniqueModels = Array.from(
//         new Set(data.data.map(item => item.carModelName).filter(Boolean))
//       ).map(modelName => ({ 
//         carModelName: formatModelName(modelName) 
//       }));
//       console.log("Fetched models:", uniqueModels.length, uniqueModels);
//       processModelList(uniqueModels);
//     } else { 
//       console.log("No models data found");
//       processModelList([]);
//     }
//     setModelsFetched(true);
//   } catch (error) { 
//     console.error("Error fetching models:", error); 
//     processModelList([]);
//     setModelsFetched(true); 
//   }
// }, [selectedCategory, selectedBrand]);

//   const fetchAllModels = useCallback(async (categoryToUse = null, brandToUse = null) => {
//   try {
//     const category = categoryToUse || selectedCategory;
//     const brand = brandToUse || selectedBrand;
    
//     // IMPORTANT: Agar dono filters blank hain, toh direct model API call karo
//     if (!category && !brand) {
//       console.log("Fetching all models from master API (no filters)");
      
//       const response = await axios.get(
//         'https://car.amar.co.jp/api/master/car-model/get/unique/model',
//         { 
//           headers: { 
//             Accept: "application/json", 
//             "Accept-Language": "en" 
//           } 
//         }
//       );
      
//       if (response.data?.carModelList && Array.isArray(response.data.carModelList)) {
//         const allModels = response.data.carModelList.map(item => ({
//           carModelName: formatModelName(item.carModelName)
//         }));
//         console.log("Fetched all models from master API:", allModels.length);
//         processModelList(allModels);
//       } else {
//         processModelList([]);
//       }
//       setModelsFetched(true);
//       return;
//     }
    
//     // Filtered API call (jab category ya brand selected ho)
//     const categoryName = category?.label || "";
//     const brandName = brand?.label || "";

//     console.log("Fetching filtered models:", { category: categoryName, brand: brandName });
    
//     const params = { 
//       categoryName: categoryName, 
//       brandName: brandName, 
//       page: '0', 
//       size: '100' 
//     };
    
//     const response = await axios.get(
//       'https://car.amar.co.jp/api/dashboard/filter/advance-filter-new', 
//       { 
//         params: params, 
//         headers: { Accept: "application/json", "Accept-Language": "en" } 
//       }
//     );
    
//     const data = response.data;
//     if (data.data && Array.isArray(data.data)) {
//       const uniqueModels = Array.from(
//         new Set(data.data.map(item => item.carModelName).filter(Boolean))
//       ).map(modelName => ({ 
//         carModelName: formatModelName(modelName) 
//       }));
//       console.log("Fetched filtered models:", uniqueModels.length);
//       processModelList(uniqueModels);
//     } else { 
//       processModelList([]);
//     }
//     setModelsFetched(true);
//   } catch (error) { 
//     console.error("Error fetching models:", error); 
//     processModelList([]);
//     setModelsFetched(true); 
//   }
// }, [selectedCategory, selectedBrand]);
// const fetchAllModels = useCallback(async (categoryToUse = null, brandToUse = null) => {
//   setIsModelsLoading(true);  // ADD THIS
//   try {
//     const category = categoryToUse || selectedCategory;
//     const brand = brandToUse || selectedBrand;
    
//     if (!category && !brand) {
//       console.log("Fetching all models from master API (no filters)");
      
//       const response = await axios.get(
//         'https://car.amar.co.jp/api/master/car-model/get/unique/model',
//         { 
//           headers: { 
//             Accept: "application/json", 
//             "Accept-Language": "en" 
//           } 
//         }
//       );
      
//       if (response.data?.carModelList && Array.isArray(response.data.carModelList)) {
//         const allModels = response.data.carModelList.map(item => ({
//           carModelName: formatModelName(item.carModelName)
//         }));
//         console.log("Fetched all models from master API:", allModels.length);
//         processModelList(allModels);
//       } else {
//         processModelList([]);
//       }
//       setModelsFetched(true);
//       return;
//     }
    
//     const categoryName = category?.label || "";
//     const brandName = brand?.label || "";

//     console.log("Fetching filtered models:", { category: categoryName, brand: brandName });
    
//     const params = { 
//       categoryName: categoryName, 
//       brandName: brandName, 
//       page: '0', 
//       size: '100' 
//     };
    
//     const response = await axios.get(
//       'https://car.amar.co.jp/api/dashboard/filter/advance-filter-new', 
//       { 
//         params: params, 
//         headers: { Accept: "application/json", "Accept-Language": "en" } 
//       }
//     );
    
//     const data = response.data;
//     if (data.data && Array.isArray(data.data)) {
//       const uniqueModels = Array.from(
//         new Set(data.data.map(item => item.carModelName).filter(Boolean))
//       ).map(modelName => ({ 
//         carModelName: formatModelName(modelName) 
//       }));
//       console.log("Fetched filtered models:", uniqueModels.length);
//       processModelList(uniqueModels);
//     } else { 
//       processModelList([]);
//     }
//     setModelsFetched(true);
//   } catch (error) { 
//     console.error("Error fetching models:", error); 
//     processModelList([]);
//     setModelsFetched(true); 
//   } finally {
//     setIsModelsLoading(false);  // ADD THIS
//   }
// }, [selectedCategory, selectedBrand]);
// const fetchAllModels = useCallback(async (categoryToUse = null, brandToUse = null) => {
//   setIsModelsLoading(true);
//   try {
//     const category = categoryToUse || selectedCategory;
//     const brand = brandToUse || selectedBrand;
    
//     if (!category && !brand) {
//       const response = await axios.get(
//         'https://car.amar.co.jp/api/master/car-model/get/unique/model',
//         { headers: { Accept: "application/json", "Accept-Language": "en" } }
//       );
      
//       if (response.data?.carModelList && Array.isArray(response.data.carModelList)) {
//         const allModelsList = response.data.carModelList.map(item => ({
//           carModelName: formatModelName(item.carModelName)
//         }));
//         processModelList(allModelsList);
//         setAllModels(allModelsList); // ✅ 1st jagah — no filter branch
//       } else {
//         processModelList([]);
//         // ❌ setAllModels nahi — kyunki data hi nahi aaya
//       }
//       setModelsFetched(true);
//       return;
//     }
    
//     const categoryName = category?.label || "";
//     const brandName = brand?.label || "";
    
//     const params = { categoryName, brandName, page: '0', size: '100' };
    
//     const response = await axios.get(
//       'https://car.amar.co.jp/api/dashboard/filter/advance-filter-new', 
//       { params, headers: { Accept: "application/json", "Accept-Language": "en" } }
//     );
    
//     const data = response.data;
//     if (data.data && Array.isArray(data.data)) {
//       const uniqueModels = Array.from(
//         new Set(data.data.map(item => item.carModelName).filter(Boolean))
//       ).map(modelName => ({ carModelName: formatModelName(modelName) }));
//       processModelList(uniqueModels);
//       setAllModels(uniqueModels); // ✅ 2nd jagah — filtered branch
//     } else { 
//       processModelList([]);
//       // ❌ setAllModels nahi — kyunki data hi nahi aaya
//     }
//     setModelsFetched(true);
//   } catch (error) { 
//     console.error("Error fetching models:", error); 
//     processModelList([]);
//     // ❌ setAllModels nahi — error case hai
//     setModelsFetched(true); 
//   } finally {
//     setIsModelsLoading(false);
//   }
// }, [selectedCategory, selectedBrand]);
// const fetchAllModels = useCallback(async (categoryToUse = null, brandToUse = null) => {
//   setIsModelsLoading(true);
//   try {
//     const category = categoryToUse || selectedCategory;
//     const brand = brandToUse || selectedBrand;

//     // Master API se saare models fetch karo
//     const response = await axios.get(
//       'https://car.amar.co.jp/api/master/car-model/get/unique/model',
//       { headers: { Accept: "application/json", "Accept-Language": "en" } }
//     );

//     if (response.data?.carModelList && Array.isArray(response.data.carModelList)) {
//       let allModelsList = response.data.carModelList.map(item => ({
//         carModelName: formatModelName(item.carModelName)
//       }));

//       // Agar brand selected hai toh brand prefix se filter karo
//       if (brand?.label) {
//         const brandPrefix = brand.label.toUpperCase();
//         allModelsList = allModelsList.filter(model =>
//           model.carModelName.toUpperCase().startsWith(brandPrefix)
//         );
//       }

//       processModelList(allModelsList);
//       setAllModels(allModelsList);
//     } else {
//       processModelList([]);
//     }
//     setModelsFetched(true);
//   } catch (error) {
//     console.error("Error fetching models:", error);
//     processModelList([]);
//     setModelsFetched(true);
//   } finally {
//     setIsModelsLoading(false);
//   }
// }, [selectedCategory, selectedBrand]);
const fetchAllModels = useCallback(async (categoryToUse = null, brandToUse = null) => {
  setIsModelsLoading(true);
  try {
    const category = categoryToUse || selectedCategory;
    const brand = brandToUse || selectedBrand;

    const params = {
      ...(category?.label && { categoryName: category.label }),
      ...(brand?.label && { brandName: brand.label }),
      page: 0,
      size: 20,
    };

    const response = await axios.get(
      'https://car.amar.co.jp/api/dashboard/filter/advance-filter-new',
      {
        params,
        headers: { Accept: "application/json", "Accept-Language": "en" },
      }
    );

    const data = response.data;

    if (data.carModelNames && Array.isArray(data.carModelNames)) {
      const uniqueModels = data.carModelNames
        .filter(Boolean)
        .map(modelName => ({ carModelName: formatModelName(modelName) }));
      processModelList(uniqueModels);
      setAllModels(uniqueModels);
    } else {
      processModelList([]);
      setAllModels([]);
    }
    setModelsFetched(true);
  } catch (error) {
    console.error("Error fetching models:", error);
    processModelList([]);
    setAllModels([]);
    setModelsFetched(true);
  } finally {
    setIsModelsLoading(false);
  }
}, [selectedCategory, selectedBrand]);


  const processModelList = (modelList) => {
    if (!Array.isArray(modelList)) {
      setPopularModels([]);
      setRemainingModels([]);
      setGroupedModels({});
      setModels([]);
      setModelsFetched(true);
      return;
    }
    
    const uniqueModels = Array.from(
      new Set(
        modelList
          .map(model => model.carModelName)
          .filter(Boolean)
          .map(formatModelName)
      )
    ).map(modelName => ({ carModelName: modelName }));
    
    console.log("Processed unique models:", uniqueModels);

    const popularModel = uniqueModels.filter((model) => 
      POPULAR_MODELS.includes(model.carModelName)
    );
    
    const remainingModel = uniqueModels.filter((model) => 
      !POPULAR_MODELS.includes(model.carModelName)
    );
    
    const groupedModel = remainingModel.reduce((acc, model) => { 
      const firstLetter = model.carModelName[0]?.toUpperCase() || 'Other';
      if (!acc[firstLetter]) { 
        acc[firstLetter] = []; 
      } 
      acc[firstLetter].push(model); 
      return acc; 
    }, {});
    
    Object.keys(groupedModel).forEach(letter => {
      groupedModel[letter].sort((a, b) => 
        a.carModelName.localeCompare(b.carModelName)
      );
    });
    
    const sortedGroupedModel = {};
    Object.keys(groupedModel).sort().forEach(key => {
      sortedGroupedModel[key] = groupedModel[key];
    });

    const validSelectedModels = selectedModels.filter(selectedModel => 
      uniqueModels.some(model => model.carModelName === selectedModel.carModelName)
    );
    
    if (validSelectedModels.length !== selectedModels.length) {
      setSelectedModels(validSelectedModels);
      setModelNameSearch(validSelectedModels.map(m => m.carModelName).join(', '));
    }

    setPopularModels(popularModel);
    setRemainingModels(remainingModel);
    setGroupedModels(sortedGroupedModel); 
    setModels(uniqueModels); 
  };
  
  // const fetchFilteredModelName = async (searchTerm) => {
  //   setModelSearchTerm(searchTerm);
  //   if (!searchTerm) { 
  //     processModelList(models); 
  //     return; 
  //   }
  //   const filtered = models.filter(model =>
  //     model.carModelName.toLowerCase().includes(searchTerm.toLowerCase())
  //   );
  //   processModelList(filtered);
  // };
  const fetchFilteredModelName = (searchTerm) => {
  setModelSearchTerm(searchTerm);
  setModelNameSearch(searchTerm);

  if (!searchTerm || searchTerm.trim() === "") {
    processModelList(allModels); // ← restore from full list
    return;
  }

  const filtered = allModels.filter(model =>
    model.carModelName.toLowerCase().includes(searchTerm.toLowerCase())
  );
  processModelList(filtered);
};

  // const handleModelSelection = (modelName) => {
  //   const modelObject = { carModelName: modelName };
  //   const isModelSelected = selectedModels.some(m => m.carModelName === modelName);
  //   let updatedSelectedModels;

  //   if (isModelSelected) {
  //     updatedSelectedModels = selectedModels.filter(m => m.carModelName !== modelName);
  //   } else {
  //     updatedSelectedModels = [...selectedModels, modelObject];
  //   }
    
  //   console.log('Updated selected models:', updatedSelectedModels);
  //   setSelectedModels(updatedSelectedModels);
  //   setModelNameSearch(updatedSelectedModels.map(m => m.carModelName).join(', '));
    
  //   notifyParentOfChange({
  //     selectedModels: updatedSelectedModels
  //   });
  // };
//   const handleModelSelection = (modelName) => {
//   const modelObject = { carModelName: modelName };
//   const isModelSelected = selectedModels.some(m => m.carModelName === modelName);
//   let updatedSelectedModels;

//   if (isModelSelected) {
//     // Agar same model click kiya toh deselect
//     updatedSelectedModels = [];
//   } else {
//     // Single selection - sirf ek model
//     updatedSelectedModels = [modelObject];
//   }
  
//   console.log('Updated selected models:', updatedSelectedModels);
//   setSelectedModels(updatedSelectedModels);
//   setModelNameSearch(updatedSelectedModels.map(m => m.carModelName).join(', '));
//   setIsSelectModelOpen(false); // Dropdown band karo
  
//   notifyParentOfChange({
//     selectedModels: updatedSelectedModels
//   });
// };

// const handleModelSelection = (modelName) => {
//   const modelObject = { carModelName: modelName };
//   const isModelSelected = selectedModels.some(m => m.carModelName === modelName);
//   let updatedSelectedModels;

//   if (isModelSelected) {
//     updatedSelectedModels = [];
//   } else {
//     updatedSelectedModels = [modelObject];
//   }
  
//   // IMPORTANT: First clear years data BEFORE setting new models
//   setYears([]);
//   setGroupedYears({});
//   setYearsFetched(false);
//   setSelectedYears([]);
//   setYearNameSearch("");
  
//   console.log('Updated selected models:', updatedSelectedModels);
//   setSelectedModels(updatedSelectedModels);
//   setModelNameSearch(updatedSelectedModels.map(m => m.carModelName).join(', '));
//   setIsSelectModelOpen(false);
  
//   // Fetch years with explicit parameters (not relying on state)
//   fetchAllYears(selectedCategory, selectedBrand, updatedSelectedModels);
  
//   notifyParentOfChange({
//     selectedModels: updatedSelectedModels,
//     selectedYears: []
//   });
// };
// const handleModelSelection = (modelName) => {
//   const modelObject = { carModelName: modelName };
//   const isModelSelected = selectedModels.some(m => m.carModelName === modelName);
//   let updatedSelectedModels;

//   if (isModelSelected) {
//     updatedSelectedModels = [];
//   } else {
//     updatedSelectedModels = [modelObject];
//   }
  
//   // Clear years data completely
//   setYears([]);
//   setGroupedYears({});
//   setYearsFetched(false);
//   setSelectedYears([]);
//   setYearNameSearch("");
  
//   console.log('Updated selected models:', updatedSelectedModels);
//   setSelectedModels(updatedSelectedModels);
//   setModelNameSearch(updatedSelectedModels.map(m => m.carModelName).join(', '));
//   setIsSelectModelOpen(false);
  
//   // Fetch years with new selection
//   fetchAllYears(selectedCategory, selectedBrand, updatedSelectedModels);
  
//   notifyParentOfChange({
//     selectedModels: updatedSelectedModels,
//     selectedYears: []
//   });
// };
const handleModelSelection = (modelName) => {
  const modelObject = { carModelName: modelName };
  const isModelSelected = selectedModels.some(m => m.carModelName === modelName);
  let updatedSelectedModels;

  if (isModelSelected) {
    updatedSelectedModels = [];
  } else {
    updatedSelectedModels = [modelObject];
  }
  
  // Clear years
  setYears([]);
  setAllYears([]);
  setGroupedYears({});
  setYearsFetched(false);
  setSelectedYears([]);
  setYearNameSearch("");
  
  setSelectedModels(updatedSelectedModels);
  setModelNameSearch(updatedSelectedModels.map(m => m.carModelName).join(', '));
  setIsSelectModelOpen(false);
  
  // ✅ IMMEDIATE FETCH with explicit params
  fetchAllYears(selectedCategory, selectedBrand, updatedSelectedModels);
  
  notifyParentOfChange({
    selectedModels: updatedSelectedModels,
    selectedYears: []
  });
};


  // const fetchAllYears = useCallback(async () => {
  //   try {
  //     const hasFilters = selectedCategory || selectedBrand || selectedModels.length > 0;
  //     if (hasFilters) {
  //       const params = { 
  //         categoryName: selectedCategory?.label || "", 
  //         brandName: selectedBrand?.label || "", 
  //         modelNames: selectedModels.map(model => model.carModelName), 
  //         page: '0', 
  //         size: '100' 
  //       };
  //       const response = await axios.get('https://car.amar.co.jp/api/dashboard/filter/advance-filter-new', { 
  //         params: params, 
  //         headers: { Accept: "application/json", "Accept-Language": "en" }, 
  //         paramsSerializer: p => qs.stringify(p, { arrayFormat: 'repeat' }) 
  //       });
  //       const data = response.data;
  //       if (data.data && Array.isArray(data.data)) {
  //         const yearList = Array.from(
  //           new Set(data.data.map(item => item.year).filter(Boolean))
  //         ).map(year => ({ year: parseInt(year) })).sort((a, b) => b.year - a.year);
  //         processYearList(yearList);
  //       } else {
  //          const currentYear = new Date().getFullYear();
  //          const initialYears = Array.from({ length: 16 }, (_, i) => ({ year: currentYear - i }));
  //          processYearList(initialYears);
  //       }
  //     } else {
  //       const currentYear = new Date().getFullYear();
  //       const initialYears = Array.from({ length: 16 }, (_, i) => ({ year: currentYear - i }));
  //       processYearList(initialYears);
  //     }
  //     setYearsFetched(true);
  //   } catch (error) { 
  //     console.error("Error fetching years:", error); 
  //     setYearsFetched(false); 
  //   }
  // }, [selectedCategory, selectedBrand, selectedModels]);

//   const fetchAllYears = useCallback(async (categoryToUse = null, brandToUse = null, modelsToUse = null) => {
//   try {
//     // Use passed parameters first, fallback to state
//     const category = categoryToUse || selectedCategory;
//     const brand = brandToUse || selectedBrand;
//     const modelsArray = modelsToUse || selectedModels;
    
//     console.log("Fetching years with filters:", {
//       category: category?.label,
//       brand: brand?.label,
//       models: modelsArray.map(m => m.carModelName)
//     });
    
//     const hasFilters = category || brand || modelsArray.length > 0;
    
//     if (hasFilters) {
//       const params = { 
//         categoryName: category?.label || "", 
//         brandName: brand?.label || "", 
//         modelNames: modelsArray.map(model => model.carModelName), 
//         page: '0', 
//         size: '100' 
//       };
//       const response = await axios.get('https://car.amar.co.jp/api/dashboard/filter/advance-filter-new', { 
//         params: params, 
//         headers: { Accept: "application/json", "Accept-Language": "en" }, 
//         paramsSerializer: p => qs.stringify(p, { arrayFormat: 'repeat' }) 
//       });
//       const data = response.data;
//       if (data.data && Array.isArray(data.data)) {
//         const yearList = Array.from(
//           new Set(data.data.map(item => item.year).filter(Boolean))
//         ).map(year => ({ year: parseInt(year) })).sort((a, b) => b.year - a.year);
//         console.log("Fetched years:", yearList.length);
//         processYearList(yearList);
//       } else {
//         const currentYear = new Date().getFullYear();
//         const initialYears = Array.from({ length: 16 }, (_, i) => ({ year: currentYear - i }));
//         processYearList(initialYears);
//       }
//     } else {
//       const currentYear = new Date().getFullYear();
//       const initialYears = Array.from({ length: 16 }, (_, i) => ({ year: currentYear - i }));
//       processYearList(initialYears);
//     }
//     setYearsFetched(true);
//   } catch (error) { 
//     console.error("Error fetching years:", error); 
//     setYearsFetched(false); 
//   }
// }, [selectedCategory, selectedBrand, selectedModels]);
// const fetchAllYears = useCallback(async (categoryToUse = null, brandToUse = null, modelsToUse = null) => {
//   try {
//     const category = categoryToUse || selectedCategory;
//     const brand = brandToUse || selectedBrand;
//     const modelsArray = modelsToUse || selectedModels;
    
//     // IMPORTANT: Agar koi filter selected nahi hai, toh direct year API call karo
//     if (!category && !brand && modelsArray.length === 0) {
//       console.log("Fetching all years from master API (no filters)");
      
//       const response = await axios.get(
//         'https://car.amar.co.jp/api/master/car-model/get/unique/years',
//         { 
//           headers: { 
//             Accept: "application/json", 
//             "Accept-Language": "en" 
//           } 
//         }
//       );
      
//       if (response.data?.data && Array.isArray(response.data.data)) {
//         const allYears = response.data.data
//           .map(item => ({ year: parseInt(item.year) }))
//           .filter(y => !isNaN(y.year) && y.year > 0) // Remove year: 0
//           .sort((a, b) => b.year - a.year);
        
//         console.log("Fetched all years from master API:", allYears.length);
//         processYearList(allYears);
//       } else {
//         // Fallback to current year range
//         const currentYear = new Date().getFullYear();
//         const initialYears = Array.from({ length: 16 }, (_, i) => ({ year: currentYear - i }));
//         processYearList(initialYears);
//       }
//       setYearsFetched(true);
//       return;
//     }
    
//     // Filtered API call (jab koi filter selected ho)
//     console.log("Fetching filtered years:", {
//       category: category?.label,
//       brand: brand?.label,
//       models: modelsArray.map(m => m.carModelName)
//     });
    
//     const params = { 
//       categoryName: category?.label || "", 
//       brandName: brand?.label || "", 
//       modelNames: modelsArray.map(model => model.carModelName), 
//       page: '0', 
//       size: '100' 
//     };
    
//     const response = await axios.get(
//       'https://car.amar.co.jp/api/dashboard/filter/advance-filter-new', 
//       { 
//         params: params, 
//         headers: { Accept: "application/json", "Accept-Language": "en" }, 
//         paramsSerializer: p => qs.stringify(p, { arrayFormat: 'repeat' }) 
//       }
//     );
    
//     const data = response.data;
//     if (data.data && Array.isArray(data.data)) {
//       const yearList = Array.from(
//         new Set(data.data.map(item => item.year).filter(Boolean))
//       ).map(year => ({ year: parseInt(year) }))
//         .filter(y => !isNaN(y.year) && y.year > 0)
//         .sort((a, b) => b.year - a.year);
      
//       console.log("Fetched filtered years:", yearList.length);
//       processYearList(yearList);
//     } else {
//       const currentYear = new Date().getFullYear();
//       const initialYears = Array.from({ length: 16 }, (_, i) => ({ year: currentYear - i }));
//       processYearList(initialYears);
//     }
//     setYearsFetched(true);
//   } catch (error) { 
//     console.error("Error fetching years:", error); 
//     setYearsFetched(false); 
//   }
// }, [selectedCategory, selectedBrand, selectedModels]);
// const fetchAllYears = useCallback(async (categoryToUse = null, brandToUse = null, modelsToUse = null) => {
//   setIsYearsLoading(true);  // ADD THIS
//   try {
//     const category = categoryToUse || selectedCategory;
//     const brand = brandToUse || selectedBrand;
//     const modelsArray = modelsToUse || selectedModels;
    
//     if (!category && !brand && modelsArray.length === 0) {
//       console.log("Fetching all years from master API (no filters)");
      
//       const response = await axios.get(
//         'https://car.amar.co.jp/api/master/car-model/get/unique/years',
//         { 
//           headers: { 
//             Accept: "application/json", 
//             "Accept-Language": "en" 
//           } 
//         }
//       );
      
//       if (response.data?.data && Array.isArray(response.data.data)) {
//         const allYears = response.data.data
//           .map(item => ({ year: parseInt(item.year) }))
//           .filter(y => !isNaN(y.year) && y.year > 0)
//           .sort((a, b) => b.year - a.year);
        
//         console.log("Fetched all years from master API:", allYears.length);
//         processYearList(allYears);
//       } else {
//         const currentYear = new Date().getFullYear();
//         const initialYears = Array.from({ length: 16 }, (_, i) => ({ year: currentYear - i }));
//         processYearList(initialYears);
//       }
//       setYearsFetched(true);
//       return;
//     }
    
//     console.log("Fetching filtered years:", {
//       category: category?.label,
//       brand: brand?.label,
//       models: modelsArray.map(m => m.carModelName)
//     });
    
//     const params = { 
//       categoryName: category?.label || "", 
//       brandName: brand?.label || "", 
//       modelNames: modelsArray.map(model => model.carModelName), 
//       page: '0', 
//       size: '100' 
//     };
    
//     const response = await axios.get(
//       'https://car.amar.co.jp/api/dashboard/filter/advance-filter-new', 
//       { 
//         params: params, 
//         headers: { Accept: "application/json", "Accept-Language": "en" }, 
//         paramsSerializer: p => qs.stringify(p, { arrayFormat: 'repeat' }) 
//       }
//     );
    
//     const data = response.data;
//     if (data.data && Array.isArray(data.data)) {
//       const yearList = Array.from(
//         new Set(data.data.map(item => item.year).filter(Boolean))
//       ).map(year => ({ year: parseInt(year) }))
//         .filter(y => !isNaN(y.year) && y.year > 0)
//         .sort((a, b) => b.year - a.year);
      
//       console.log("Fetched filtered years:", yearList.length);
//       processYearList(yearList);
//     } else {
//       const currentYear = new Date().getFullYear();
//       const initialYears = Array.from({ length: 16 }, (_, i) => ({ year: currentYear - i }));
//       processYearList(initialYears);
//     }
//     setYearsFetched(true);
//   } catch (error) { 
//     console.error("Error fetching years:", error); 
//     setYearsFetched(false); 
//   } finally {
//     setIsYearsLoading(false);  // ADD THIS
//   }
// }, [selectedCategory, selectedBrand, selectedModels]);
const fetchAllYears = useCallback(async (categoryToUse = null, brandToUse = null, modelsToUse = null) => {
  setIsYearsLoading(true);
  try {
    const category = categoryToUse || selectedCategory;
    const brand = brandToUse || selectedBrand;
    const modelsArray = modelsToUse || selectedModels;
    
    if (!category && !brand && modelsArray.length === 0) {
      const response = await axios.get(
        'https://car.amar.co.jp/api/master/car-model/get/unique/years',
        { headers: { Accept: "application/json", "Accept-Language": "en" } }
      );
      
      if (response.data?.data && Array.isArray(response.data.data)) {
        const allYearsList = response.data.data
          .map(item => ({ year: parseInt(item.year) }))
          .filter(y => !isNaN(y.year) && y.year > 0)
          .sort((a, b) => b.year - a.year);
        
        processYearList(allYearsList);
        setAllYears(allYearsList); // ✅ 1st jagah — no filter branch
      } else {
        const currentYear = new Date().getFullYear();
        const initialYears = Array.from({ length: 16 }, (_, i) => ({ year: currentYear - i }));
        processYearList(initialYears);
        setAllYears(initialYears); // ✅ fallback bhi save karo
      }
      setYearsFetched(true);
      return;
    }
    
    const params = { 
      categoryName: category?.label || "", 
      brandName: brand?.label || "", 
      modelNames: modelsArray.map(model => model.carModelName), 
      page: '0', 
      size: '100' 
    };
    
    const response = await axios.get(
      'https://car.amar.co.jp/api/dashboard/filter/advance-filter-new', 
      { 
        params, 
        headers: { Accept: "application/json", "Accept-Language": "en" }, 
        paramsSerializer: p => qs.stringify(p, { arrayFormat: 'repeat' }) 
      }
    );
    
    const data = response.data;
    if (data.data && Array.isArray(data.data)) {
      const yearList = Array.from(
        new Set(data.data.map(item => item.year).filter(Boolean))
      ).map(year => ({ year: parseInt(year) }))
        .filter(y => !isNaN(y.year) && y.year > 0)
        .sort((a, b) => b.year - a.year);
      
      processYearList(yearList);
      setAllYears(yearList); // ✅ 2nd jagah — filtered branch
    } else {
      const currentYear = new Date().getFullYear();
      const initialYears = Array.from({ length: 16 }, (_, i) => ({ year: currentYear - i }));
      processYearList(initialYears);
      // ❌ setAllYears nahi — actual data nahi aaya API se
    }
    setYearsFetched(true);
  } catch (error) { 
    console.error("Error fetching years:", error); 
    setYearsFetched(false); 
    // ❌ setAllYears nahi — error case hai
  } finally {
    setIsYearsLoading(false);
  }
}, [selectedCategory, selectedBrand, selectedModels]);

  // const processYearList = (data) => {
  //   if (!Array.isArray(data)) return;
  //   const uniqueYears = Array.from(
  //     new Set(data.map(item => typeof item.year === 'number' ? item.year : parseInt(item.year)))
  //   ).filter(year => !isNaN(year) && year > 1900 && year <= new Date().getFullYear())
  //    .map(year => ({ year: year }))
  //    .sort((a, b) => b.year - a.year);
     
  //   const groupedYear = uniqueYears.reduce((acc, yearObj) => { 
  //     const decade = Math.floor(yearObj.year / 10) * 10; 
  //     if (!acc[decade]) { 
  //       acc[decade] = []; 
  //     } 
  //     acc[decade].push(yearObj); 
  //     return acc; 
  //   }, {});
    
  //   const validSelectedYears = selectedYears.filter(selectedYear => 
  //     uniqueYears.some(year => year.year === selectedYear.year)
  //   );
    
  //   if (validSelectedYears.length !== selectedYears.length) {
  //     setSelectedYears(validSelectedYears);
  //     setYearNameSearch(validSelectedYears.map(y => y.year).join(', '));
  //   }

  //   setGroupedYears(groupedYear); 
  //   setYears(uniqueYears);
  // };
  
  const processYearList = (data) => {
  if (!Array.isArray(data)) return;
  
  const uniqueYears = Array.from(
    new Set(data.map(item => typeof item.year === 'number' ? item.year : parseInt(item.year)))
  ).filter(year => !isNaN(year) && year > 1900 && year <= new Date().getFullYear() + 1) // Allow current + 1 year
   .map(year => ({ year: year }))
   .sort((a, b) => b.year - a.year);
   
  const groupedYear = uniqueYears.reduce((acc, yearObj) => { 
    const decade = Math.floor(yearObj.year / 10) * 10; 
    if (!acc[decade]) { 
      acc[decade] = []; 
    } 
    acc[decade].push(yearObj); 
    return acc; 
  }, {});
  
  const validSelectedYears = selectedYears.filter(selectedYear => 
    uniqueYears.some(year => year.year === selectedYear.year)
  );
  
  if (validSelectedYears.length !== selectedYears.length) {
    setSelectedYears(validSelectedYears);
    setYearNameSearch(validSelectedYears.map(y => y.year).join(', '));
  }

  setGroupedYears(groupedYear); 
  setYears(uniqueYears);
};

  // const fetchFilteredYearName = async (searchTerm) => {
  //   setYearSearchTerm(searchTerm);
  //   if (!searchTerm) { 
  //     processYearList(years); 
  //     return; 
  //   }
  //   const filtered = years.filter(yearObj =>
  //     yearObj.year.toString().includes(searchTerm)
  //   );
  //   processYearList(filtered);
  // };
  const fetchFilteredYearName = (searchTerm) => {
  setYearSearchTerm(searchTerm);
  setYearNameSearch(searchTerm);

  if (!searchTerm || searchTerm.trim() === "") {
    processYearList(allYears); // ← restore from full list
    return;
  }

  const filtered = allYears.filter(yearObj =>
    yearObj.year.toString().includes(searchTerm)
  );
  processYearList(filtered);
};

  // const handleYearSelection = (year) => {
  //   const yearObject = { year };
  //   const isYearSelected = selectedYears.some(y => y.year === year);
  //   let updatedSelectedYears;

  //   if (isYearSelected) {
  //     updatedSelectedYears = selectedYears.filter(y => y.year !== year);
  //   } else {
  //     updatedSelectedYears = [...selectedYears, yearObject];
  //   }
    
  //   console.log('Updated selected years:', updatedSelectedYears);
  //   setSelectedYears(updatedSelectedYears);
  //   setYearNameSearch(updatedSelectedYears.map(y => y.year).join(', '));
    
  //   notifyParentOfChange({
  //     selectedYears: updatedSelectedYears
  //   });
  // };
  
  const handleYearSelection = (year) => {
  const yearObject = { year };
  const isYearSelected = selectedYears.some(y => y.year === year);
  let updatedSelectedYears;

  if (isYearSelected) {
    updatedSelectedYears = selectedYears.filter(y => y.year !== year);
  } else {
    updatedSelectedYears = [...selectedYears, yearObject];
  }
  
  console.log('Updated selected years:', updatedSelectedYears);
  setSelectedYears(updatedSelectedYears);
  setYearNameSearch(updatedSelectedYears.map(y => y.year).join(', '));
  
  notifyParentOfChange({
    selectedYears: updatedSelectedYears
  });
};

  useEffect(() => { 
    fetchAllCategories(); 
  }, []); 
  
  useEffect(() => { 
    fetchAllBrands(); 
  }, [selectedCategory, fetchAllBrands]); 

  useEffect(() => {
  if (selectedBrand) {
    fetchAllModels(selectedCategory, selectedBrand);
  } else {
    setModels([]);
    setAllModels([]);
    setPopularModels([]);
    setRemainingModels([]);
    setGroupedModels({});
    setModelsFetched(true);
  }
}, [selectedCategory, selectedBrand]);

  // useEffect(() => { 
  //   fetchAllModels();
  // }, [selectedCategory, selectedBrand, fetchAllModels]);
//   useEffect(() => { 
//   if (!selectedCategory && !selectedBrand && selectedModels.length === 0) {
//     fetchAllYears(null, null, []);
//   } else {
//     fetchAllYears(selectedCategory, selectedBrand, selectedModels);
//   }
// }, [selectedCategory, selectedBrand, selectedModels]);
useEffect(() => { 
  if (memoizedInitialState.selectedYears?.length > 0) {
    return; // ✅ Parent se years aa rahe hain toh fetch mat karo
  }
  if (!selectedCategory && !selectedBrand && selectedModels.length === 0) {
    fetchAllYears(null, null, []);
  } else {
    fetchAllYears(selectedCategory, selectedBrand, selectedModels);
  }
}, [selectedCategory, selectedBrand, selectedModels]);
  
  // useEffect(() => { 
  //   if (selectedBrand) {
  //     fetchAllModels();
  //   } else {
  //     setModels([]);
  //     setPopularModels([]);
  //     setRemainingModels([]);
  //     setGroupedModels({});
  //     setModelsFetched(true);
  //   }
  // }, [selectedCategory, selectedBrand, fetchAllModels]); 

  // useEffect(() => { 
  //   if (selectedBrand) {
  //     fetchAllModels(selectedCategory, selectedBrand);  // Pass both explicitly
  //   } else {
  //     setModels([]);
  //     setPopularModels([]);
  //     setRemainingModels([]);
  //     setGroupedModels({});
  //     setModelsFetched(true);
  //   }
  // }, [selectedCategory, selectedBrand]);  // Remove fetchAllModels from dependency

  // Ise maine comment kiya iske badle koi useEffect add ni kiya bs ise htana tha ////////////////////////////////
//   useEffect(() => { 
//   // Agar koi filter selected nahi hai, tab bhi models load karo
//   if (!selectedCategory && !selectedBrand) {
//     console.log("Loading all models (no filters selected)");
//     fetchAllModels(null, null);
//   } else if (selectedBrand) {
//     console.log("Loading filtered models");
//     fetchAllModels(selectedCategory, selectedBrand);
//   } else {
//     // Only clear if there's a category but no brand
//     setModels([]);
//     setPopularModels([]);
//     setRemainingModels([]);
//     setGroupedModels({});
//     setModelsFetched(true);
//   }
// }, [selectedCategory, selectedBrand]);

  
  // useEffect(() => { 
  //   fetchAllYears(); 
  // }, [selectedCategory, selectedBrand, selectedModels, fetchAllYears]); 
//   useEffect(() => { 
//   fetchAllYears(selectedCategory, selectedBrand, selectedModels);
// }, [selectedCategory, selectedBrand, selectedModels]);
// useEffect(() => { 
//   // Agar koi filter selected nahi hai, tab bhi years load karo
//   if (!selectedCategory && !selectedBrand && selectedModels.length === 0) {
//     console.log("Loading all years (no filters selected)");
//     fetchAllYears(null, null, []);
//   } else {
//     console.log("Loading filtered years");
//     fetchAllYears(selectedCategory, selectedBrand, selectedModels);
//   }
// }, [selectedCategory, selectedBrand, selectedModels]);
  
  useEffect(() => { 
    setBrandNameSearch(selectedBrand?.label || '');
  }, [selectedBrand]);

  useEffect(() => { 
    setModelNameSearch(selectedModels.map(m => m.carModelName).join(', '));
  }, [selectedModels]);

  useEffect(() => { 
    setYearNameSearch(selectedYears.map(y => y.year).join(', '));
  }, [selectedYears]);

  const handleSearch = async () => {
    try {
      const currentCategory = selectedCategory ? { ...selectedCategory } : null;
      const currentBrand = selectedBrand ? { ...selectedBrand } : null;
      const currentModels = selectedModels.map(m => m.carModelName); 
      const currentYears = selectedYears.map(y => y.year); 

      console.log('Executing search with:', {
        category: currentCategory,
        brand: currentBrand,
        models: currentModels,
        years: currentYears
      });

      let navParams = {
        categoryName: currentCategory?.label || "", 
        brandName: currentBrand?.label || "",
        modelNames: currentModels, 
        years: currentYears,
        colorSelect: memoizedInitialState.colorSelect, 
        carDriveType: memoizedInitialState.carDriveType, 
        carEngine: memoizedInitialState.carEngine,
        carFilterAccessories: memoizedInitialState.carFilterAccessories, 
        carFuelType: memoizedInitialState.carFuelType,
        carMileage: memoizedInitialState.carMileage, 
        carPrice: memoizedInitialState.carPrice, 
        carSeat: memoizedInitialState.carSeat,
        carSteering: memoizedInitialState.carSteering, 
        carTransmission: memoizedInitialState.carTransmission,
        globalSearch: memoizedInitialState.globalSearch,
        page: 1, 
        size: 20,
      };

      navParams = Object.fromEntries(
          Object.entries(navParams).filter(([_, v]) => 
            v !== "" && v !== null && v !== undefined && (Array.isArray(v) ? v.length > 0 : true)
          )
      );
      
      const response = await dispatch(performAdvanceFilter(
        currentCategory, currentBrand, selectedModels, selectedYears, 0, 20, 
        navParams.colorSelect, navParams.carDriveType, navParams.carEngine, navParams.carFilterAccessories, 
        navParams.carFuelType, navParams.carMileage, navParams.carPrice, navParams.carSeat, 
        navParams.carSteering, navParams.carTransmission, navParams.globalSearch
      ));
      
      const finalFilterState = {
        selectedCategory: currentCategory, 
        selectedBrand: currentBrand, 
        selectedModels: selectedModels, 
        selectedYears: selectedYears,
        ...memoizedInitialState,
        ...navParams, 
      };

      const searchString = qs.stringify(navParams, { arrayFormat: "repeat", encode: false });

      navigate(
        { pathname: "/FilterByGlobalSearch", search: `?${searchString}` },
        { 
          state: { 
            filterState: finalFilterState, 
            totalItems: response.totalItems, 
            key: Date.now() 
          } 
        }
      );
      
      notifyParentOfChange(finalFilterState);
    } catch (error) {
      console.error("Search failed:", error);
      enqueueSnackbar("Search failed. Please try again.", { variant: "error" });
    }
  };

  const renderGroupedBrands = () => {
    if (remainingBrands.length === 0) {
      return (
        <Box sx={{ textAlign: 'center', padding: '20px' }}>
          <Typography>No brands found</Typography>
        </Box>
      );
    }

    return Object.keys(groupedBrands).sort().map((letter) => (
        <Box key={letter} sx={{ marginTop: "10px" }}>
            <Typography sx={{ fontWeight: "bold", fontSize: { xs: "14px", md: "16px" }, marginBottom: "5px" }}>{letter}</Typography>
            <RadioGroup value={selectedBrand?.label || ""}>
                <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "0px" }}>
                    {groupedBrands[letter].map((brand, index) => (
                        <FormControlLabel 
                          key={index} 
                          value={brand.carBrandName}
                          control={
                            <Radio 
                              checked={brand.carBrandName === selectedBrand?.label} 
                              sx={{ "& .MuiSvgIcon-root": { fontSize: "18px" } }} 
                            />
                          }
                          label={
                            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <Box component="img" src={getBrandImage(brand.carBrandName)} alt={brand.carBrandName} sx={{ height: "25px", width: "25px" }} />
                                <Typography component="span" variant="body1" sx={{ fontSize: { xs: "11px", md: "12px" }, fontWeight: "600" }}>
                                  {brand.carBrandName}
                                </Typography>
                            </Box>
                          }
                          onClick={() => handleBrandSelection(brand.carBrandName)}
                        />
                    ))}
                </Box>
            </RadioGroup>
        </Box>
    ));
  };

  const renderGroupedModels = () => {
    if (models.length === 0) {
      let message = 'No models found';
      
      if (!selectedCategory && !selectedBrand) {
        message = 'Loading all available models...';
      } else if (selectedBrand && selectedCategory) {
        message = `No models found for ${selectedBrand.label} in ${selectedCategory.label}`;
      } else if (selectedBrand) {
        message = `No models found for ${selectedBrand.label}`;
      } else if (selectedCategory) {
        message = `No models found for ${selectedCategory.label}`;
      }

      return (
        <Box sx={{ textAlign: "center", padding: "20px" }}>
          <Typography>{message}</Typography>
        </Box>
      );
    }
    
    return Object.keys(groupedModels)
      .sort()
      .map((letter) => (
        <Box key={letter} sx={{ marginTop: "10px" }}>
          <Typography sx={{ fontWeight: "bold", fontSize: { xs: "14px", md: "16px" }, marginBottom: "5px" }}>{letter}</Typography>
          <FormGroup>
            <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "0px" }}>
              {groupedModels[letter].map((model, index) => (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      checked={selectedModels.some(m => m.carModelName === model.carModelName)}
                      onChange={() => handleModelSelection(model.carModelName)}
                      sx={{ "& .MuiSvgIcon-root": { fontSize: "18px" } }}
                    />
                  }
                  label={
                    <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <Typography component="span" variant="body1" sx={{ fontSize: { xs: "11px", md: "12px" }, fontWeight: "600" }}>
                        {model.carModelName}
                      </Typography>
                    </Box>
                  }
                />
              ))}
            </Box>
          </FormGroup>
        </Box>
      ));
  };
  
  const renderGroupedYears = () => {
    if (years.length === 0) {
      return (
        <Box sx={{ textAlign: 'center', padding: '20px' }}>
          <Typography>No years found</Typography>
        </Box>
      );
    }

    return Object.keys(groupedYears).sort((a, b) => b - a).map((decade) => (
        <Box key={decade} sx={{ marginTop: "8px" }}>
            <FormGroup>
                {/* <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: { xs: "8px 10px", md: "8px 12px" }, padding: "0 8px" }}> */}
                <Box 
                  sx={{
                    display: "grid",
                    padding: "0 8px",
                    width: "100%",
                    gap: "6px 6px",

                    /* 320px */
                    "@media (min-width:320px)": {
                      gridTemplateColumns: "repeat(3, 1fr)",
                      gap: "6px 1px",
                    },

                    /* 375px */
                    "@media (min-width:375px)": {
                      gridTemplateColumns: "repeat(3, 1fr)",
                    },

                    /* 425px */
                    "@media (min-width:425px)": {
                      gridTemplateColumns: "repeat(3, 1fr)",
                      gap: "6px 26px",
                    },

                    /* 768px */
                    "@media (min-width:768px)": {
                      gridTemplateColumns: "repeat(, 1fr)",
                      gap: "6px 12px",
                    },

                    /* 1024px */
                    "@media (min-width:1024px)": {
                      gridTemplateColumns: "repeat(3, 1fr)",
                    },

                    /* 1440px */
                    "@media (min-width:1440px)": {
                      gridTemplateColumns: "repeat(3, 1fr)",
                    },

                    /* 1920px */
                    "@media (min-width:1920px)": {
                      gridTemplateColumns: "repeat(3, 1fr)",
                      gap: "8px 20px",
                    },

                    /* 2560px */
                    "@media (min-width:2560px)": {
                      gridTemplateColumns: "repeat(4, 1fr)",
                      gap: "16px 30px",
                    },
                  }}
                >
                    {groupedYears[decade].map((yearObj, index) => (
                        <FormControlLabel 
                          key={index}
                          control={
                            <Checkbox 
                              checked={selectedYears.some(y => y.year === yearObj.year)} 
                              onChange={() => handleYearSelection(yearObj.year)} 
                              className="custom-checkbox"
                              size="small"
                              sx={{ padding: "4px 6px", marginRight: "4px" }}
                            />
                          }
                          label={<span className="custom-label" style={{ fontSize: "12px", fontWeight: "500" }}>{yearObj.year}</span>}
                          sx={{ margin: "0", display: "flex", alignItems: "center", justifyContent: "flex-start" }}
                        />
                    ))}
                </Box>
            </FormGroup>
        </Box>
    ));
  };

  const DropdownLoader = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "40px 20px",
      gap: 2,
    }}
  >
    <Box
      component="img"
      src="/image/footer-logo-small.svg"
      alt="Loading..."
      sx={{
        width: 50,
        height: 50,
      }}
    />
    <Typography sx={{ color: "#666", fontSize: "13px" }}>Loading...</Typography>
  </Box>
);

  return (
  <Box
    sx={{
      width: '100%',
      background: '#E9242A',
      padding: '10px 16px',
    }}
  >
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(6, 1fr)',
        },
        gap: '10px',
        alignItems: 'center',
      }}
    >
      {/* 1. Body Type Dropdown */}
<FormControl fullWidth size="small">
  <Select
    labelId="vehicle-type-label"
    id="vehicle-type"
    value={selectedCategory ? selectedCategory.label : ""}
    open={isDropdownOpen}
    onOpen={handleSelectOpen}
    onClose={() => setIsDropdownOpen(false)}
    displayEmpty
    IconComponent={ExpandMoreIcon}
    renderValue={(selected) => {
      if (!selected || selected === "") {
        return <Typography sx={{ color: "#888" }}>Pick Body Type</Typography>;
      }
      const selectedType = bodyTypes.find((type) => type.label === selected);
      return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {selectedType && (
            <>
              <Box component="img" src={selectedType.src} alt={selected} sx={{ width: 20, height: 20 }} />
              <span>{selected}</span>
            </>
          )}
        </Box>
      );
    }}
    MenuProps={{
      disableAutoFocusItem: true,
      disableEnforceFocus: true,
      PaperProps: {
        sx: {
          width: "300px",
          mt: 1,
          overflow: "hidden", // Important: Paper ka scroll band
        }
      },
      MenuListProps: {
        sx: {
          padding: 0,
          display: "flex",
          flexDirection: "column",
          maxHeight: { xs: "70vh", sm: "60vh", md: "55vh" },
          overflow: "hidden", // MenuList ka bhi scroll band
        }
      }
    }}
    sx={{
      height: 42,
      backgroundColor: "#fff",
      borderRadius: "6px",
      "& .MuiOutlinedInput-notchedOutline": { border: "none" },
      "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
    }}
  >
    {/* Search Box - Fixed at Top */}
    <Box 
      sx={{ 
        p: 2, 
        pb: 1, 
        backgroundColor: "#fff",
        flexShrink: 0, // Ye shrink nahi hoga
      }}
    >
      <TextField
        fullWidth
        size="small"
        placeholder="Search body type..."
        value={categorySearch}
        onChange={(e) => {
          setCategorySearch(e.target.value);
          fetchFilteredCategories(e.target.value);
        }}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "#999" }} />
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "6px",
            backgroundColor: "#f5f5f5",
            "& fieldset": { border: "none" },
          }
        }}
      />
    </Box>

    {/* Scrollable Body Types Grid - Sirf ye scroll hoga */}
    {/* <Box
      sx={{
        flex: 1,
        overflowY: "auto",
        overflowX: "hidden",
        minHeight: 0, // Important for flex scroll
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: { xs: 1, sm: 1.5 },
          p: { xs: 1.5, sm: 2 },
          pt: 1,
        }}
      >
        {filteredBodyTypes.map((item, index) => (
          <Box
            key={index}
            onClick={(e) => {
              selectCategory(item, e);
              setIsDropdownOpen(false);
            }}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: { xs: "10px 6px", sm: "12px 8px", md: "14px 10px" },
              border: selectedCategory?.label === item.label ? "2px solid #E9242A" : "1px solid #e0e0e0",
              borderRadius: "8px",
              cursor: "pointer",
              backgroundColor: selectedCategory?.label === item.label ? "#fff5f5" : "#fff",
              transition: "all 0.2s",
              "&:hover": {
                borderColor: "#E9242A",
                backgroundColor: "#fff5f5",
              },
            }}
          >
            <Box
              component="img"
              src={item.src}
              alt={item.label}
              sx={{
                width: { xs: 26, sm: 30, md: 34 },
                height: "auto",
                mb: 0.5,
              }}
            />
            <Typography
              sx={{
                fontSize: { xs: "9px", sm: "10px", md: "11px" },
                fontWeight: selectedCategory?.label === item.label ? 600 : 500,
                textAlign: "center",
                color: selectedCategory?.label === item.label ? "#E9242A" : "#333",
                textTransform: "uppercase",
              }}
            >
              {item.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box> */}
    <Box
  sx={{
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
    minHeight: 0,
  }}
>
  {isCategoriesLoading ? (
    <DropdownLoader />
  ) : (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: { xs: 1, sm: 1.5 },
        p: { xs: 1.5, sm: 2 },
        pt: 1,
      }}
    >
      {filteredBodyTypes.map((item, index) => (
        <Box
          key={index}
          onClick={(e) => {
            selectCategory(item, e);
            setIsDropdownOpen(false);
          }}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: { xs: "10px 6px", sm: "12px 8px", md: "14px 10px" },
            border: selectedCategory?.label === item.label ? "2px solid #E9242A" : "1px solid #e0e0e0",
            borderRadius: "8px",
            cursor: "pointer",
            backgroundColor: selectedCategory?.label === item.label ? "#fff5f5" : "#fff",
            transition: "all 0.2s",
            "&:hover": {
              borderColor: "#E9242A",
              backgroundColor: "#fff5f5",
            },
          }}
        >
          <Box
            component="img"
            src={item.src}
            alt={item.label}
            sx={{
              width: { xs: 26, sm: 30, md: 34 },
              height: "auto",
              mb: 0.5,
            }}
          />
          <Typography
            sx={{
              fontSize: { xs: "9px", sm: "10px", md: "11px" },
              fontWeight: selectedCategory?.label === item.label ? 600 : 500,
              textAlign: "center",
              color: selectedCategory?.label === item.label ? "#E9242A" : "#333",
              textTransform: "uppercase",
            }}
          >
            {item.label}
          </Typography>
        </Box>
      ))}
    </Box>
  )}
</Box>

    {/* Reset Button - Fixed at Bottom */}
    <Box 
      sx={{ 
        p: 2, 
        pt: 1.5,
        borderTop: "1px solid #e0e0e0",
        backgroundColor: "#fff",
        flexShrink: 0, // Ye bhi shrink nahi hoga
      }}
    >
      <Button
        fullWidth
        onClick={(e) => {
          e.stopPropagation();
          handleBodyTypeReset();
        }}
        sx={{
          textTransform: "uppercase",
          color: "#fff",
          backgroundColor:"#E9242A",
          fontWeight: 600,
          "&:hover": {
            // backgroundColor: "#f5f5f5",
            backgroundColor: "red",
          },
        }}
      >
        RESET
      </Button>
    </Box>
  </Select>
</FormControl>

      {/* 2. Brand Dropdown */}
      <FormControl fullWidth size="small">
  <Select
    labelId="brand-label"
    id="brand"
    value={selectedBrand?.label || ""}
    open={isSelectBrandOpen}
    onOpen={() => {
      if (!brandsFetched) {
        fetchAllBrands();
        setBrandsFetched(true);
      }
      setIsSelectBrandOpen(true);
    }}
    onClose={() => setIsSelectBrandOpen(false)}
    displayEmpty
    IconComponent={ExpandMoreIcon}
    renderValue={(selected) => {
      if (!selected || selected === "") {
        return <Typography sx={{ color: "#888" }}>Pick a Brand</Typography>;
      }
      return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box component="img" src={getBrandImage(selected)} alt={selected} sx={{ width: 20, height: 20 }} />
          <span style={{ fontWeight: "500" }}>{selected}</span>
        </Box>
      );
    }}
    MenuProps={{
      disableAutoFocusItem: true,
      disableEnforceFocus: true,
      PaperProps: {
        sx: {
          width: "300px",
          mt: 1,
          overflow: "hidden", // Paper ka scroll band
        }
      },
      MenuListProps: {
        sx: {
          padding: 0,
          display: "flex",
          flexDirection: "column",
          maxHeight: { xs: "70vh", sm: "60vh", md: "55vh" },
          overflow: "hidden", // MenuList ka bhi scroll band
        }
      }
    }}
    sx={{
      height: 42,
      backgroundColor: "#fff",
      borderRadius: "6px",
      "& .MuiOutlinedInput-notchedOutline": { border: "none" },
      "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
    }}
  >
    {/* Search Box - Fixed at Top */}
    <Box 
      sx={{ 
        p: 2, 
        pb: 1,
        backgroundColor: "#fff",
        flexShrink: 0,
      }}
    >
      <TextField
        fullWidth
        size="small"
        placeholder="Search brand..."
        value={brandNameSearch}
        onChange={(e) => {
          setBrandNameSearch(e.target.value);
          fetchFilteredBrandName(e.target.value);
        }}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "#999" }} />
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "6px",
            backgroundColor: "#f5f5f5",
            "& fieldset": { border: "none" },
          }
        }}
      />
    </Box>

    {/* Scrollable Content Area - Sirf ye scroll hoga */}
    <Box
  sx={{
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
    minHeight: 0,
  }}
>
  {isBrandsLoading ? (
    <DropdownLoader />
  ) : (
    <>
      {/* Popular Car Brands Section */}
      {/* {!searchTerm && ( */}
      {popularBrands.length > 0 && (
        <Box sx={{ px: 2, pb: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 1 }}>
            <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#333" }}>
              Popular Car Brands
            </Typography>
            <Typography sx={{ fontSize: "13px", color: "#E9242A" }}>▶</Typography>
          </Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: 1,
            }}
          >
            {popularBrands.map((brand, index) => (
              <Box
                key={index}
                onClick={() => {
                  handleBrandSelection(brand.carBrandName);
                  setIsSelectBrandOpen(false);
                }}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px 6px",
                  border: selectedBrand?.label === brand.carBrandName ? "2px solid #E9242A" : "1px solid #e0e0e0",
                  borderRadius: "8px",
                  cursor: "pointer",
                  backgroundColor: selectedBrand?.label === brand.carBrandName ? "#fff5f5" : "#fff",
                  transition: "all 0.2s",
                  "&:hover": {
                    borderColor: "#E9242A",
                    backgroundColor: "#fff5f5",
                  },
                }}
              >
                <Box
                  component="img"
                  src={getBrandImage(brand.carBrandName)}
                  alt={brand.carBrandName}
                  sx={{ width: 28, height: 28, mb: 0.5 }}
                />
                <Typography
                  sx={{
                    fontSize: "9px",
                    fontWeight: 600,
                    textAlign: "center",
                    color: selectedBrand?.label === brand.carBrandName ? "#E9242A" : "#333",
                    textTransform: "uppercase",
                  }}
                >
                  {brand.carBrandName}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      )}

      {/* All Car Brands Section */}
      <Box sx={{ px: 2, pb: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 1 }}>
          <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#333" }}>
            All Car Brands
          </Typography>
          <Typography sx={{ fontSize: "13px", color: "#E9242A" }}>▶</Typography>
        </Box>

        <Box>
          {Object.keys(groupedBrands).sort().map((letter) => (
            <Box key={letter} sx={{ mb: 1.5 }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 700,
                  color: "#333",
                  mb: 0.5,
                }}
              >
                {letter}
              </Typography>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: 0.5,
                }}
              >
                {groupedBrands[letter].map((brand, index) => (
                  <Box
                    key={index}
                    onClick={() => {
                      handleBrandSelection(brand.carBrandName);
                      setIsSelectBrandOpen(false);
                    }}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      padding: "6px 8px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      transition: "all 0.2s",
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: 16,
                        height: 16,
                        border: selectedBrand?.label === brand.carBrandName
                          ? "2px solid #E9242A"
                          : "2px solid #d0d0d0",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        backgroundColor:"#fff",
                        transition: "all 0.2s",
                      }}
                    >
                      {selectedBrand?.label === brand.carBrandName && (
                        <Box
                          sx={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            backgroundColor: "#E9242A",
                          }}
                        />
                      )}
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: selectedBrand?.label === brand.carBrandName ? 600 : 400,
                        color: selectedBrand?.label === brand.carBrandName ? "#E9242A" : "#333",
                      }}
                    >
                      {brand.carBrandName}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          ))}

          {Object.keys(groupedBrands).length === 0 && !isBrandsLoading && (
            <Box sx={{ textAlign: "center", py: 2 }}>
              <Typography sx={{ color: "#999", fontSize: "13px" }}>
                No brands found
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </>
  )}
</Box>

    {/* Reset Button - Fixed at Bottom */}
    <Box 
      sx={{ 
        p: 2, 
        pt: 1, 
        borderTop: "1px solid #e0e0e0",
        backgroundColor: "#fff",
        flexShrink: 0,
      }}
    >
      <Button
        fullWidth
        onClick={(e) => {
          e.stopPropagation();
          handleBrandReset();
        }}
        sx={{
          textTransform: "uppercase",
          color: "#fff",
          fontWeight: 600,
          backgroundColor:"#E9242A",
          "&:hover": {
            backgroundColor: "red",
          },
        }}
      >
        RESET
      </Button>
    </Box>
  </Select>
</FormControl>

      {/* 3. Model Dropdown */}
      <FormControl fullWidth size="small">
  <Select
    labelId="model-label"
    id="model"
    value={selectedModels}
    multiple
    open={isSelectModelOpen}
    // onOpen={() => {
    //   if (!modelsFetched) {
    //     fetchAllModels();
    //     setModelsFetched(true);
    //   }
    //   setIsSelectModelOpen(true);
    // }}
    onOpen={() => {
  // Check if brand is selected
  if (!selectedBrand) {
    // Brand not selected - open brand dropdown instead
    setIsSelectBrandOpen(true);
    enqueueSnackbar("Please select a brand first", { 
      variant: "warning",
      autoHideDuration: 2000 
    });
    return; // Don't open model dropdown
  }
  
  // Brand is selected - proceed normally
  if (!modelsFetched) {
    fetchAllModels();
    setModelsFetched(true);
  }
  setIsSelectModelOpen(true);
}}
    onClose={() => setIsSelectModelOpen(false)}
    displayEmpty
    IconComponent={ExpandMoreIcon}
    // renderValue={(selected) => {
    //   if (!selectedModels.length) {
    //     return <Typography sx={{ color: "#888" }}>Pick Car Models</Typography>;
    //   }
    //   return (
    //     <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flexWrap: "wrap" }} onClick={(e) => e.stopPropagation()}>
    //       {selectedModels.slice(0, 1).map((model, index) => (
    //         <Chip
    //           key={index}
    //           label={model.carModelName}
    //           size="small"
    //           onMouseDown={(e) => e.stopPropagation()}
    //           onDelete={(e) => {
    //             e.stopPropagation();
    //             setSelectedModels(selectedModels.filter((m) => m.carModelName !== model.carModelName));
    //           }}
    //           sx={{ height: "22px", fontSize: "11px", '& .MuiChip-deleteIcon': { color: '#E9242A', fontSize: '16px' } }}
    //         />
    //       ))}
    //       {selectedModels.length > 1 && (
    //         <Chip label={`+${selectedModels.length - 1}`} size="small" sx={{ height: "22px", fontSize: "11px", backgroundColor: "#eee" }} />
    //       )}
    //     </Box>
    //   );
    // }}
//     renderValue={(selected) => {
//   if (!selectedModels.length) {
//     return <Typography sx={{ color: "#888" }}>Pick Car Model</Typography>;
//   }
//   return (
//     <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//       <span style={{ fontWeight: "500" }}>{selectedModels[0].carModelName}</span>
//     </Box>
//   );
// }}
renderValue={(selected) => {
  if (!selectedBrand) {
    return <Typography sx={{ color: "#aaa" }}>Select Brand First</Typography>;
  }
  if (!selectedModels.length) {
    return <Typography sx={{ color: "#888" }}>Pick Car Model</Typography>;
  }
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <span style={{ fontWeight: "500" }}>{selectedModels[0].carModelName}</span>
    </Box>
  );
}}
    MenuProps={{
      disableAutoFocusItem: true,
      disableEnforceFocus: true,
      PaperProps: {
        sx: {
          width: "300px",
          mt: 1,
          overflow: "hidden",
        }
      },
      MenuListProps: {
        sx: {
          padding: 0,
          display: "flex",
          flexDirection: "column",
          maxHeight: { xs: "70vh", sm: "60vh", md: "55vh" },
          overflow: "hidden",
        }
      }
    }}
    sx={{
      height: 42,
      backgroundColor: "#fff",
      borderRadius: "6px",
      "& .MuiOutlinedInput-notchedOutline": { border: "none" },
      "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
    }}
  >
    {/* Search Box - Fixed at Top */}
    <Box 
      sx={{ 
        p: 2, 
        pb: 1,
        backgroundColor: "#fff",
        flexShrink: 0,
      }}
    >
      <TextField
        fullWidth
        size="small"
        placeholder="Search models..."
        value={modelNameSearch}
        onChange={(e) => {
          setModelNameSearch(e.target.value);
          fetchFilteredModelName(e.target.value);
        }}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "#999" }} />
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "6px",
            backgroundColor: "#f5f5f5",
            "& fieldset": { border: "none" },
          }
        }}
      />
    </Box>

    {/* Scrollable Content Area - Sirf ye scroll hoga */}
    <Box
  sx={{
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
    minHeight: 0,
  }}
>
  {isModelsLoading ? (
    <DropdownLoader />
  ) : (
    <>
      {/* Popular Car Models Section */}
      {!modelSearchTerm && popularModels.length > 0 && (
        <Box sx={{ px: 2, pb: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 1 }}>
            <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#333" }}>
              Popular Car Models
            </Typography>
            <Typography sx={{ fontSize: "13px", color: "#E9242A" }}>▶</Typography>
          </Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: 1,
            }}
          >
            {popularModels.slice(0, 3).map((model, index) => (
              <Box
                key={index}
                onClick={() => handleModelSelection(model.carModelName)}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px 6px",
                  border: selectedModels.some(m => m.carModelName === model.carModelName)
                    ? "2px solid #E9242A"
                    : "1px solid #e0e0e0",
                  borderRadius: "8px",
                  cursor: "pointer",
                  backgroundColor: selectedModels.some(m => m.carModelName === model.carModelName)
                    ? "#fff5f5"
                    : "#fff",
                  transition: "all 0.2s",
                  "&:hover": {
                    borderColor: "#E9242A",
                    backgroundColor: "#fff5f5",
                  },
                }}
              >
                <Box
                  component="img"
                  src={getModelImage(model.carModelName) || "/BrandIcons/default.svg"}
                  alt={model.carModelName}
                  sx={{ width: 28, height: 28, mb: 0.5 }}
                />
                <Typography
                  sx={{
                    fontSize: "9px",
                    fontWeight: 600,
                    textAlign: "center",
                    color: selectedModels.some(m => m.carModelName === model.carModelName)
                      ? "#E9242A"
                      : "#333",
                    textTransform: "uppercase",
                  }}
                >
                  {model.carModelName}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      )}

      {/* All Car Models Section */}
      <Box sx={{ px: 2, pb: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 1 }}>
          <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#333" }}>
            All Car Models
          </Typography>
          <Typography sx={{ fontSize: "13px", color: "#E9242A" }}>▶</Typography>
        </Box>

        <Box>
          {Object.keys(groupedModels).sort().map((letter) => (
            <Box key={letter} sx={{ mb: 1.5 }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 700,
                  color: "#333",
                  mb: 0.5,
                }}
              >
                {letter}
              </Typography>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: 0.5,
                }}
              >
                {groupedModels[letter].map((model, index) => (
                  <Box
                    key={index}
                    onClick={() => handleModelSelection(model.carModelName)}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      padding: "6px 8px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      transition: "all 0.2s",
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: 16,
                        height: 16,
                        border: selectedModels.some(m => m.carModelName === model.carModelName)
                          ? "2px solid #E9242A"
                          : "2px solid #d0d0d0",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        backgroundColor: "#fff",
                        transition: "all 0.2s",
                      }}
                    >
                      {selectedModels.some(m => m.carModelName === model.carModelName) && (
                        <Box
                          sx={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            backgroundColor: "#E9242A",
                          }}
                        />
                      )}
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: selectedModels.some(m => m.carModelName === model.carModelName) ? 600 : 400,
                        color: selectedModels.some(m => m.carModelName === model.carModelName) ? "#E9242A" : "#333",
                      }}
                    >
                      {model.carModelName}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          ))}

          {Object.keys(groupedModels).length === 0 && !isModelsLoading && (
            <Box sx={{ textAlign: "center", py: 2 }}>
              <Typography sx={{ color: "#999", fontSize: "13px" }}>
                No models found
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </>
  )}
</Box>

    {/* Reset Button - Fixed at Bottom */}
    <Box 
      sx={{ 
        p: 2, 
        pt: 1, 
        borderTop: "1px solid #e0e0e0",
        backgroundColor: "#fff",
        flexShrink: 0,
      }}
    >
      <Button
        fullWidth
        onClick={(e) => {
          e.stopPropagation();
          handleModelReset();
        }}
        sx={{
          textTransform: "uppercase",
          color: "#fff",
          fontWeight: 600,
          backgroundColor:"#E9242A",
          "&:hover": {
            backgroundColor: "red",
          },
        }}
      >
        RESET
      </Button>
    </Box>
  </Select>
</FormControl>

      {/* 4. Year Dropdown */}
      <FormControl fullWidth size="small">
  <Select
    labelId="year-label"
    id="year"
    value={selectedYears}
    multiple
    open={isSelectYearOpen}
    onOpen={() => {
      if (!yearsFetched) {
        fetchAllYears();
        setYearsFetched(true);
      }
      setIsSelectYearOpen(true);
    }}
    onClose={() => setIsSelectYearOpen(false)}
    displayEmpty
    IconComponent={ExpandMoreIcon}
    renderValue={(selected) => {
      if (!selectedYears.length) {
        return <Typography sx={{ color: "#888" }}>Pick Model Years</Typography>;
      }
      return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flexWrap: "wrap" }} onClick={(e) => e.stopPropagation()}>
          {selectedYears.slice(0, 1).map((yearObj, index) => (
            <Chip
              key={index}
              label={yearObj.year}
              size="small"
              onMouseDown={(e) => e.stopPropagation()}
              onDelete={(e) => {
                e.stopPropagation();
                setSelectedYears(selectedYears.filter((y) => y.year !== yearObj.year));
              }}
              sx={{ height: "22px", fontSize: "11px", '& .MuiChip-deleteIcon': { color: '#E9242A', fontSize: '16px' } }}
            />
          ))}
          {selectedYears.length > 1 && (
            <Chip label={`+${selectedYears.length - 1}`} size="small" sx={{ height: "22px", fontSize: "11px", backgroundColor: "#eee" }} />
          )}
        </Box>
      );
    }}
    MenuProps={{
      disableAutoFocusItem: true,
      disableEnforceFocus: true,
      PaperProps: {
        sx: {
          width: "300px",
          mt: 1,
          overflow: "hidden",
        }
      },
      MenuListProps: {
        sx: {
          padding: 0,
          display: "flex",
          flexDirection: "column",
          maxHeight: { xs: "70vh", sm: "60vh", md: "55vh" },
          overflow: "hidden",
        }
      }
    }}
    sx={{
      height: 42,
      backgroundColor: "#fff",
      borderRadius: "6px",
      "& .MuiOutlinedInput-notchedOutline": { border: "none" },
      "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
    }}
  >
    {/* Search Years Header - Fixed at Top */}
    <Box 
      sx={{ 
        px: 2, 
        pt: 2, 
        pb: 1,
        backgroundColor: "#fff",
        flexShrink: 0,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 1.5 }}>
        <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#333" }}>
          Search Years
        </Typography>
        <Typography sx={{ fontSize: "13px", color: "#E9242A" }}>▶</Typography>
      </Box>
      
      {/* Search Box */}
      <TextField
        fullWidth
        size="small"
        placeholder="Search years..."
        value={yearNameSearch}
        onChange={(e) => {
          setYearNameSearch(e.target.value);
          fetchFilteredYearName(e.target.value);
        }}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "6px",
            backgroundColor: "#f5f5f5",
            "& fieldset": { border: "none" },
          }
        }}
      />
    </Box>

    {/* Years Grid - Scrollable Content Area */}
    {/* <Box 
      sx={{ 
        flex: 1,
        overflowY: "auto",
        overflowX: "hidden",
        minHeight: 0,
        px: 2, 
        py: 1,
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 1,
        }}
      >
        {years.map((yearObj, index) => (
          <Box
            key={index}
            onClick={() => handleYearSelection(yearObj.year)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              padding: "8px",
              borderRadius: "4px",
              cursor: "pointer",
              transition: "all 0.2s",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            <Box
              sx={{
                width: 18,
                height: 18,
                border: selectedYears.some(y => y.year === yearObj.year)
                  ? "2px solid #E9242A"
                  : "2px solid #d0d0d0",
                borderRadius: "3px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                backgroundColor: selectedYears.some(y => y.year === yearObj.year)
                  ? "#E9242A"
                  : "#fff",
                transition: "all 0.2s",
              }}
            >
              {selectedYears.some(y => y.year === yearObj.year) && (
                <Typography sx={{ color: "#fff", fontSize: "12px", lineHeight: 1 }}>
                  ✓
                </Typography>
              )}
            </Box>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: selectedYears.some(y => y.year === yearObj.year) ? 600 : 400,
                color: selectedYears.some(y => y.year === yearObj.year) ? "#E9242A" : "#333",
              }}
            >
              {yearObj.year}
            </Typography>
          </Box>
        ))}
      </Box>

      {years.length === 0 && (
        <Box sx={{ textAlign: "center", py: 2 }}>
          <Typography sx={{ color: "#999", fontSize: "13px" }}>
            No years found
          </Typography>
        </Box>
      )}
    </Box> */}
    <Box 
  sx={{ 
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
    minHeight: 0,
    px: 2, 
    py: 1,
  }}
>
  {isYearsLoading ? (
    <DropdownLoader />
  ) : (
    <>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 1,
        }}
      >
        {years.map((yearObj, index) => (
          <Box
            key={index}
            onClick={() => handleYearSelection(yearObj.year)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              padding: "8px",
              borderRadius: "4px",
              cursor: "pointer",
              transition: "all 0.2s",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            <Box
              sx={{
                width: 18,
                height: 18,
                border: selectedYears.some(y => y.year === yearObj.year)
                  ? "2px solid #E9242A"
                  : "2px solid #d0d0d0",
                borderRadius: "3px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                backgroundColor: selectedYears.some(y => y.year === yearObj.year)
                  ? "#E9242A"
                  : "#fff",
                transition: "all 0.2s",
              }}
            >
              {selectedYears.some(y => y.year === yearObj.year) && (
                <Typography sx={{ color: "#fff", fontSize: "12px", lineHeight: 1 }}>
                  ✓
                </Typography>
              )}
            </Box>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: selectedYears.some(y => y.year === yearObj.year) ? 600 : 400,
                color: selectedYears.some(y => y.year === yearObj.year) ? "#E9242A" : "#333",
              }}
            >
              {yearObj.year}
            </Typography>
          </Box>
        ))}
      </Box>

      {years.length === 0 && !isYearsLoading && (
        <Box sx={{ textAlign: "center", py: 2 }}>
          <Typography sx={{ color: "#999", fontSize: "13px" }}>
            No years found
          </Typography>
        </Box>
      )}
    </>
  )}
</Box>

    {/* Reset Button - Fixed at Bottom */}
    <Box 
      sx={{ 
        p: 2, 
        pt: 1, 
        borderTop: "1px solid #e0e0e0",
        backgroundColor: "#fff",
        flexShrink: 0,
      }}
    >
      <Button
        fullWidth
        onClick={(e) => {
          e.stopPropagation();
          handleYearReset();
        }}
        sx={{
          textTransform: "uppercase",
          color: "#fff",
          fontWeight: 600,
          backgroundColor:"#E9242A",
          "&:hover": {
            backgroundColor: "red",
          },
        }}
      >
        RESET
      </Button>
    </Box>
  </Select>
</FormControl>

      {/* 5. More Filter Button */}
      <Button
        variant="contained"
        startIcon={<FilterAltOutlinedIcon />}
        onClick={handleOpenFilterModal}
        sx={{
          height: 42,
          background: "linear-gradient(135deg, #FF6B6B 0%, #E9242A 100%)",
          borderRadius: "6px",
          textTransform: "none",
          fontWeight: 600,
          fontSize: "14px",
          "&:hover": {
            background: "linear-gradient(135deg, #FF5252 0%, #D32F2F 100%)",
          },
        }}
      >
        More Filter
      </Button>

      {/* 6. Search Button */}
      <Button
        variant="contained"
        startIcon={<SearchIcon />}
        onClick={handleSearch}
        sx={{
          height: 42,
          background: "#C62828",
          borderRadius: "6px",
          textTransform: "none",
          fontWeight: 700,
          fontSize: "14px",
          "&:hover": {
            background: "#B71C1C",
          },
        }}
      >
        Search
      </Button>
    </Box>

    {/* More Filter Dialog - no changes */}
    <MoreFilterDialog
      open={filterModalOpen}
      onClose={handleCloseFilterModal}
      // onApplyFilters={(filters) => {
      //   notifyParentOfChange(filters);
      // }}
      onApplyFilters={(filters) => {
        // Update BasicSelectFilter's own states
        setSelectedCategory(filters.selectedCategory);
        setSelectedBrand(filters.selectedBrand);
        setSelectedModels(filters.selectedModels || []);
        setSelectedYears(filters.selectedYears || []);
        
        // Update search fields
        setCategorySearch(filters.selectedCategory?.label || "");
        setBrandNameSearch(filters.selectedBrand?.label || "");
        setModelNameSearch((filters.selectedModels || []).map(m => m.carModelName).join(', '));
        setYearNameSearch((filters.selectedYears || []).map(y => y.year).join(', '));
        
        // Notify parent
        notifyParentOfChange(filters);
      }}
      initialFilters={{
        selectedCategory: selectedCategory,
        selectedBrand: selectedBrand,
        selectedModels: selectedModels,
        selectedYears: selectedYears,
        categoryName: selectedCategory?.label || '',
        brandName: selectedBrand?.label || '',
        modelNames: selectedModels.map(m => m.carModelName),
        years: selectedYears.map(y => y.year),
        colorSelect: memoizedInitialState.colorSelect,
        carDriveType: memoizedInitialState.carDriveType,
        carEngine: memoizedInitialState.carEngine,
        carFilterAccessories: memoizedInitialState.carFilterAccessories,
        carFuelType: memoizedInitialState.carFuelType,
        carMileage: memoizedInitialState.carMileage,
        carPrice: memoizedInitialState.carPrice,
        carSeat: memoizedInitialState.carSeat,
        carSteering: memoizedInitialState.carSteering,
        carTransmission: memoizedInitialState.carTransmission,
      }}
      currentData={{
        data: currentFilteredData.data,
        totalItems: currentFilteredData.totalItems
      }}
    />
  </Box>
);
}